"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9585],{

/***/ 98417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ corePdpLink; }
/* harmony export */ });
var corePdpLink = function(slug, addressToken) {
    return "/properties/".concat(encodeURIComponent(slug), "/aid_").concat(addressToken);
};


/***/ }),

/***/ 63149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ isBuyDirectEligible; }
/* harmony export */ });
/**
 * Determines if a property is eligible for buy-direct features. Property must
 * have BUY_DIRECT_ELIGIBLE tag (set by backend based on BUY_DIRECT_MARKETS).
 *
 * @param property - The property to check
 * @returns true if buy-direct features should be shown for this property
 */ var isBuyDirectEligible = function(property) {
    var ref;
    var ref1;
    // Market gate (respects BUY_DIRECT_MARKETS from backend)
    return (ref1 = (ref = property.listingTags) === null || ref === void 0 ? void 0 : ref.includes("BUY_DIRECT_ELIGIBLE")) !== null && ref1 !== void 0 ? ref1 : false;
};


/***/ }),

/***/ 95707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Dm": function() { return /* reexport */ formatStreetAddress; },
  "pX": function() { return /* reexport */ buyDirectHelpers/* isBuyDirectEligible */.p; },
  "O8": function() { return /* reexport */ usePropertyReactions; },
  "FZ": function() { return /* reexport */ useSellerDisclosures; },
  "n6": function() { return /* reexport */ useSimilarProperties; },
  "ad": function() { return /* reexport */ useTrackProperty/* useTrackProperty */.a; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/__generated__/protobuf/journey/data/categories/marketplace_property_category.ts
var marketplace_property_category = __webpack_require__(46329);
// EXTERNAL MODULE: ./src/components/api/index.ts + 2 modules
var api = __webpack_require__(67945);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var useTrackProperty = __webpack_require__(97997);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/usePropertyReactions.ts









var redirectToLogin = function(addressId) {
    var url = new URL(window.location.toString());
    url.searchParams.append("likedId", addressId);
    window.location.assign("/login?redirectTo=".concat(encodeURIComponent(url.toString())));
    return;
};
var initialState = {
    isDisliked: false,
    isLiked: false,
    isLoading: false
};
var checkIfLiked = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(addressToken) {
        var ref, res, ref1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!addressToken) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertyReaction({
                            addressToken: addressToken
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (ref1 = (ref = res.marketplace.property) === null || ref === void 0 ? void 0 : ref.isLiked) !== null && ref1 !== void 0 ? ref1 : false
                    ];
                case 2:
                    return [
                        2,
                        false
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function checkIfLiked(addressToken) {
        return _ref.apply(this, arguments);
    };
}();
var likeProperty = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(addressId, customerId, source) {
        var e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().SetMarketplacePropertyReaction({
                            input: {
                                addressId: addressId,
                                customerId: customerId,
                                reaction: "REACTION_LIKE",
                                source: source
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function likeProperty(addressId, customerId, source) {
        return _ref.apply(this, arguments);
    };
}();
var unlikeProperty = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(addressId, customerId) {
        var e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().RemoveMarketplacePropertyReaction({
                            input: {
                                addressId: addressId,
                                customerId: customerId
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        false
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function unlikeProperty(addressId, customerId) {
        return _ref.apply(this, arguments);
    };
}();
var usePropertyReactions = function(addressId) {
    var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "REACTION_SOURCE_WEB_PDP";
    var ref = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref.authentication, user = ref.user;
    var router = (0,next_router.useRouter)();
    var isLoggedIn = authentication.state === "authenticated";
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var likedIdExists = router.query["likedId"] === addressId;
    var onFinishLikedId = function() {
        delete router.query["likedId"];
        router.replace({
            query: router.query
        }, undefined, {
            shallow: true
        });
    };
    (0,react.useEffect)(function() {
        if (!isLoggedIn || !addressId) {
            return;
        }
        if (likedIdExists && (user === null || user === void 0 ? void 0 : user.customerUuid)) {
            dispatch({
                type: "START_TOGGLE_FAVORITE"
            });
            likeProperty(addressId, user === null || user === void 0 ? void 0 : user.customerUuid, source).then(function(res) {
                dispatch({
                    type: "SET_FAVORITE",
                    payload: {
                        isLiked: res
                    }
                });
            }).finally(function() {
                onFinishLikedId();
            });
            return;
        }
        checkIfLiked(addressId).then(function(res) {
            dispatch({
                type: "SET_FAVORITE",
                payload: {
                    isLiked: res
                }
            });
        });
    }, [
        isLoggedIn,
        likedIdExists
    ]);
    var reducer = function(state, action) {
        switch(action.type){
            case "START_TOGGLE_FAVORITE":
                if (state.isLiked) {
                    return {
                        isLiked: false,
                        isLoading: true,
                        isDisliked: false
                    };
                }
                return {
                    isLiked: true,
                    isLoading: true,
                    isDisliked: false
                };
            case "SET_FAVORITE":
                return {
                    isLiked: action.payload.isLiked,
                    isLoading: false,
                    isDisliked: false
                };
        }
    };
    var ref1 = (0,react.useReducer)(reducer, initialState), state = ref1[0], dispatch = ref1[1];
    var onClickReaction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var trackingLabel, propertyReaction, reactionLabel, _tmp, _tmp1, onClickReactionEvent;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!addressId) {
                        return [
                            2
                        ];
                    }
                    if (!isLoggedIn && addressId) {
                        trackProperty("property-favorite", "redirect-to-login");
                        return [
                            2,
                            redirectToLogin(addressId)
                        ];
                    }
                    dispatch({
                        type: "START_TOGGLE_FAVORITE"
                    });
                    trackingLabel = state.isLiked ? "remove-favorite" : "add-favorite";
                    propertyReaction = state.isLiked ? unlikeProperty : likeProperty;
                    reactionLabel = state.isLiked ? marketplace_property_category/* MarketplacePropertyCategory_ReactionEventReaction.REACTION_REMOVE_LIKE */.AJ.REACTION_REMOVE_LIKE : marketplace_property_category/* MarketplacePropertyCategory_ReactionEventReaction.REACTION_ADD_LIKE */.AJ.REACTION_ADD_LIKE;
                    if (!(user === null || user === void 0 ? void 0 : user.customerUuid)) return [
                        3,
                        2
                    ];
                    _tmp = {
                        type: "SET_FAVORITE"
                    };
                    _tmp1 = {};
                    return [
                        4,
                        propertyReaction(addressId, user === null || user === void 0 ? void 0 : user.customerUuid, source)
                    ];
                case 1:
                    dispatch.apply(void 0, [
                        (_tmp.payload = (_tmp1.isLiked = _state.sent(), _tmp1), _tmp)
                    ]);
                    trackProperty("property-favorite", trackingLabel);
                    trackJourneyEvent("marketplaceProperty", "reaction", {
                        addressUuid: addressId,
                        reaction: reactionLabel,
                        source: source ? source : "marketplace-pdp"
                    });
                    onClickReactionEvent = new Event("propertyReactionEvent");
                    window.dispatchEvent(onClickReactionEvent);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        state.isLiked,
        isLoggedIn,
        user
    ]);
    return {
        onClickReaction: onClickReaction,
        isLiked: state.isLiked,
        isLoading: state.isLoading
    };
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSimilarProperties.ts


var useSimilarProperties = function(addressToken) {
    var ref = (0,react.useState)(), similarProperties = ref[0], setSimilarProperties = ref[1];
    (0,react.useEffect)(function() {
        if (!addressToken) {
            return;
        }
        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertySimilarProperties({
            addressToken: addressToken
        }).then(function(data) {
            var ref, ref1;
            setSimilarProperties(data === null || data === void 0 ? void 0 : (ref = data.marketplace) === null || ref === void 0 ? void 0 : (ref1 = ref.property) === null || ref1 === void 0 ? void 0 : ref1.similarProperties);
        });
    }, [
        addressToken
    ]);
    return {
        similarProperties: similarProperties
    };
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSellerDisclosures.ts


var useSellerDisclosures = function(addressToken) {
    var ref = (0,react.useState)(), sellerDisclosures = ref[0], setSellerDisclosures = ref[1];
    (0,react.useEffect)(function() {
        if (!addressToken) {
            return;
        }
        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertySellerDisclosures({
            addressToken: addressToken
        }).then(function(data) {
            var ref, ref1;
            setSellerDisclosures(data === null || data === void 0 ? void 0 : (ref = data.marketplace) === null || ref === void 0 ? void 0 : (ref1 = ref.property) === null || ref1 === void 0 ? void 0 : ref1.sellerDisclosuresDownloadUrl);
        });
    }, [
        addressToken
    ]);
    return {
        sellerDisclosures: sellerDisclosures
    };
};

// EXTERNAL MODULE: ./src/components/marketplace/helpers/buyDirectHelpers.ts
var buyDirectHelpers = __webpack_require__(63149);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/addressHelpers.ts
/**
 * Formats a street address with unit type and number if available.
 * @param street - The street address
 * @param unitType - Optional unit type (e.g., "Apt", "Unit", "Suite")
 * @param unitNumber - Optional unit number
 * @returns Formatted street address with unit information, or null if street is not provided
 */ function formatStreetAddress(street, unitType, unitNumber) {
    if (!street) {
        return null;
    }
    if (unitType && unitNumber) {
        return "".concat(street, " ").concat(unitType, " ").concat(unitNumber);
    }
    if (unitNumber) {
        return "".concat(street, " #").concat(unitNumber);
    }
    return street;
}

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/index.ts








/***/ }),

/***/ 82799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fM": function() { return /* binding */ TOUR_ACTION_TEXT_BUY_DIRECT; },
/* harmony export */   "ms": function() { return /* binding */ TOUR_ACTION_TEXT_NON_BUY_DIRECT; },
/* harmony export */   "zf": function() { return /* binding */ determinePropertyActionability; }
/* harmony export */ });
/* harmony import */ var _buyDirectHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63149);

var TOUR_ACTION_TEXT_NON_BUY_DIRECT = {
    selfTour: "Self-tour",
    tourWithAgent: "Share home"
};
var TOUR_ACTION_TEXT_BUY_DIRECT = {
    selfTour: "Self-tour",
    tourWithAgent: "Tour with agent"
};
/**
 * Determines if a property is actionable (can be toured or purchased) and what type of tour is available.
 *
 * Badge meanings (determined in athena transformToDisplayBadge):
 * - ON_THE_MARKET: Property is for sale AND canSelfTour=true
 * - TRADITIONAL: Property is for sale BUT canSelfTour=false (MLS listing, requires agent)
 * - UNKNOWN: Property status unclear, check canSelfTour flag
 *
 * @param property - The property to check
 * @returns Object with isActionable flag, tour kind (null if not actionable), and whether to show buy direct
 */ var determinePropertyActionability = function(property) {
    var ref;
    var isUnknownRequiresAgent = property.displayBadge === "UNKNOWN" && !property.canSelfTour;
    // TRADITIONAL always implies canSelfTour=false. This is determined in athena
    var canTourWithAgent = property.displayBadge === "TRADITIONAL" || isUnknownRequiresAgent;
    // ON_THE_MARKET badge always implies canSelfTour=true. This is determined in athena.
    var isActionable = property.displayBadge === "ON_THE_MARKET" || canTourWithAgent;
    // Determine if buy direct should be shown
    var showBuyDirect = (0,_buyDirectHelpers__WEBPACK_IMPORTED_MODULE_0__/* .isBuyDirectEligible */ .p)(property) && !!property.buyDirectPrice;
    var ref1;
    // Check if property has any tags that would disqualify it from BuyDirect
    var hasDisqualifyingTags = (ref1 = (ref = property.listingTags) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
        return tag !== "BUY_DIRECT_ELIGIBLE";
    })) !== null && ref1 !== void 0 ? ref1 : false;
    // Determine if buy direct button should be disabled (property is under contract)
    var disableBuyDirect = property.displayBadge === "IN_CONTRACT" || property.listingState === "IN_CONTRACT" || hasDisqualifyingTags;
    // Determine the tour kind based on property data, null if not actionable
    var tourKind = null;
    if (isActionable) {
        tourKind = canTourWithAgent ? "tourWithAgent" : "selfTour";
    }
    return {
        isActionable: isActionable,
        tourKind: tourKind,
        showBuyDirect: showBuyDirect,
        disableBuyDirect: disableBuyDirect
    };
};


/***/ }),

/***/ 97997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PropertyAnalytics; },
/* harmony export */   "a": function() { return /* binding */ useTrackProperty; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95674);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77997);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35480);
/* harmony import */ var _shared_trackers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59431);







var initialPropertyContext = {
    property: undefined
};
var PropertyAnalytics = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialPropertyContext);
var usePropertyAnalytics = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PropertyAnalytics);
};
/**
 * Geenerate the payload for the trackProperty function, exported for testing
 */ function buildPayload(property) {
    var additionalContextualData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, user = arguments.length > 2 ? arguments[2] : void 0;
    var trackPropertyFields = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (property === null || property === void 0 ? void 0 : property.city) && {
        city: property === null || property === void 0 ? void 0 : property.city
    }, (property === null || property === void 0 ? void 0 : property.state) && {
        state: property === null || property === void 0 ? void 0 : property.state
    }, (property === null || property === void 0 ? void 0 : property.zip) && {
        zip: property === null || property === void 0 ? void 0 : property.zip
    }, (property === null || property === void 0 ? void 0 : property.slug) && {
        slug: property === null || property === void 0 ? void 0 : property.slug
    }, (property === null || property === void 0 ? void 0 : property.addressToken) && {
        addressToken: property === null || property === void 0 ? void 0 : property.addressToken
    }, (property === null || property === void 0 ? void 0 : property.listingState) && {
        listingState: property === null || property === void 0 ? void 0 : property.listingState
    }, (property === null || property === void 0 ? void 0 : property.canSelfTour) && {
        canSelfTour: property === null || property === void 0 ? void 0 : property.canSelfTour
    });
    var properties = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, additionalContextualData, trackPropertyFields), {
        anonymousId: (0,_shared_trackers__WEBPACK_IMPORTED_MODULE_4__/* .getAnonymousId */ .y)()
    }), (user === null || user === void 0 ? void 0 : user.customerUuid) && {
        customerId: user.customerUuid
    });
    // Filter out any keys where the value is empty
    var payload = Object.keys(properties).filter(function(key) {
        return properties[key];
    }).reduce(function(obj, key) {
        obj[key] = properties[key];
        return obj;
    }, {});
    return payload;
}
var useTrackProperty = function() {
    var analytics = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_2__/* .useObservability */ .C3)();
    var property = usePropertyAnalytics().property;
    var user = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)().user;
    var trackProperty = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(featureName, label) {
        var additionalContextualData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var action = featureName;
        var payload = buildPayload(property, additionalContextualData, user);
        analytics.trackEvent(action, label, payload);
        if (_globals__WEBPACK_IMPORTED_MODULE_3__/* .DEPLOY_ENV */ .Zp === "development") {
            console.debug("[Analytics]", {
                featureName: featureName,
                label: label,
                payload: payload
            });
        }
    }, [
        analytics.trackEvent,
        property
    ]);
    return {
        trackProperty: trackProperty
    };
};


/***/ }),

/***/ 79338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PricingTraditional; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_shared_fe_formatUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64260);



var PricingTraditional = function(param) {
    var listPrice = param.listPrice;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        flexDirection: "row",
        alignItems: "center",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            typography: "$headerMedium",
            tag: "h2",
            color: "$contentPrimary",
            pb: 24,
            children: listPrice ? (0,_opendoor_shared_fe_formatUtils__WEBPACK_IMPORTED_MODULE_0__/* .formatCurrency */ .xG)(listPrice) : "Price not available"
        })
    });
};


/***/ }),

/***/ 28561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ PropertyCTAs; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/propertyActionability.ts
var propertyActionability = __webpack_require__(82799);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(60179);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconTruckFilled.mjs
var IconTruckFilled = __webpack_require__(77178);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconShieldLockFilled.mjs
var IconShieldLockFilled = __webpack_require__(29513);
;// CONCATENATED MODULE: ./src/components/marketplace/property/BottomSheet.tsx



var SWIPE_THRESHOLD = 50;
var BottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, children = param.children;
    var ref = (0,react.useState)(null), swipeStartY = ref[0], setSwipeStartY = ref[1];
    var ref1 = (0,react.useState)(0), currentTranslateY = ref1[0], setCurrentTranslateY = ref1[1];
    var ref2 = (0,react.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    var ref3 = (0,react.useState)(false), isAnimating = ref3[0], setIsAnimating = ref3[1];
    var ref4 = (0,react.useState)(false), isDragging = ref4[0], setIsDragging = ref4[1];
    (0,react.useEffect)(function() {
        if (isOpen) {
            setIsVisible(true);
            setTimeout(function() {
                return setIsAnimating(true);
            }, 10);
            return undefined;
        }
        setIsAnimating(false);
        setCurrentTranslateY(0);
        var timer = setTimeout(function() {
            return setIsVisible(false);
        }, 300);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isOpen
    ]);
    var handleTouchStart = function(e) {
        var ref, ref1;
        var touch = (ref = e.nativeEvent) === null || ref === void 0 ? void 0 : (ref1 = ref.touches) === null || ref1 === void 0 ? void 0 : ref1[0];
        if (touch) {
            setSwipeStartY(touch.pageY);
        }
    };
    var handleTouchMove = function(e) {
        var ref, ref1;
        if (swipeStartY === null) return;
        var touch = (ref = e.nativeEvent) === null || ref === void 0 ? void 0 : (ref1 = ref.touches) === null || ref1 === void 0 ? void 0 : ref1[0];
        if (!touch) return;
        var swipeDistance = touch.pageY - swipeStartY;
        // Only drag if swiping down
        if (swipeDistance > 0) {
            setCurrentTranslateY(swipeDistance);
            setIsDragging(true);
        }
    };
    var handleTouchEnd = function() {
        if (swipeStartY === null) return;
        setIsDragging(false);
        setSwipeStartY(null);
        if (currentTranslateY > SWIPE_THRESHOLD) {
            onClose();
        } else {
            setCurrentTranslateY(0);
        }
    };
    if (!isVisible) return null;
    var getTranslateY = function() {
        if (isDragging) return "".concat(currentTranslateY, "px");
        if (isAnimating) return "0";
        return "100%";
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        style: {
            position: "fixed",
            backgroundColor: "rgba(0, 0, 0, ".concat(isAnimating ? 0.7 : 0, ")"),
            transition: "background-color 200ms ease-out",
            touchAction: "none"
        },
        onTouchStart: function(e) {
            e.preventDefault();
            onClose();
        },
        onTouchMove: function(e) {
            return e.preventDefault();
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            flexDirection: "column",
            onTouchStart: function(e) {
                return e.stopPropagation();
            },
            style: {
                transform: "translateY(".concat(getTranslateY(), ")"),
                transition: isDragging ? "none" : "transform 300ms cubic-bezier(0.32, 0.72, 0, 1)"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: "100%",
                    paddingTop: "$3x",
                    paddingBottom: "$4x",
                    flexDirection: "column",
                    alignItems: "center",
                    onTouchStart: handleTouchStart,
                    onTouchMove: handleTouchMove,
                    onTouchEnd: handleTouchEnd,
                    style: {
                        cursor: "grab"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        borderRadius: "$full",
                        width: 88,
                        height: 8,
                        backgroundColor: "$borderPrimary"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: "100%",
                    backgroundColor: "$backgroundPrimary",
                    borderTopLeftRadius: "$16x",
                    borderTopRightRadius: "$16x",
                    onTouchStart: handleTouchStart,
                    onTouchMove: handleTouchMove,
                    onTouchEnd: handleTouchEnd,
                    children: children
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/property/BuyWithConfidence.tsx





var BuyWithConfidence = function() {
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var smallerThanMD = (0,cjs.useMedia)().smallerThanMD;
    var ref1 = (0,react.useState)(false), isVerySmall = ref1[0], setIsVerySmall = ref1[1];
    (0,react.useEffect)(function() {
        if (!isModalOpen) return;
        var checkWidth = function() {
            // iPhone SE and iPhone 13 Mini screen resolution is right at 375,
            // which the current breakpoints don't handle.
            setIsVerySmall(window.innerWidth <= 375);
        };
        checkWidth();
        window.addEventListener("resize", checkWidth);
        return function() {
            return window.removeEventListener("resize", checkWidth);
        };
    }, [
        isModalOpen
    ]);
    var getModalTitleTypography = function() {
        if (!smallerThanMD) return "$headerSmall";
        return isVerySmall ? "$subheaderSmall" : "$subheaderLarge";
    };
    var getModalSubtitleTypography = function() {
        if (!smallerThanMD) return "$bodyLarge";
        return isVerySmall ? "$bodySmall" : "$bodyMedium";
    };
    var modalContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        maxWidth: 552,
        marginHorizontal: "auto",
        width: "100%",
        paddingHorizontal: smallerThanMD ? "$16x" : "$6x",
        paddingTop: smallerThanMD ? "$16x" : 0,
        paddingBottom: smallerThanMD ? "$16x" : 0,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            flexDirection: "column",
            gap: "$12x",
            alignItems: "center",
            paddingTop: 0,
            paddingBottom: 0,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    flexDirection: "column",
                    gap: "$4x",
                    alignItems: "center",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            src: isVerySmall ? "https://images.opendoor.com/source/s3/imgdrop-production/2025-12-1764962388442-16990.png?preset=square-128&service=cosmos-cache-friendly&dpr=2" : "https://images.opendoor.com/source/s3/imgdrop-production/2025-12-1764882992132-81635.png?preset=square-128&service=cosmos-cache-friendly&dpr=2",
                            alt: "Opendoor Guarantee",
                            width: isVerySmall ? 60 : 82,
                            height: isVerySmall ? 60 : 82
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            flexDirection: "column",
                            gap: "$2x",
                            alignItems: "center",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "h2",
                                    typography: getModalTitleTypography(),
                                    color: "$contentPrimary",
                                    textAlign: "center",
                                    children: "The Opendoor Guarantee"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: getModalSubtitleTypography(),
                                    color: "$contentTertiary",
                                    textAlign: "center",
                                    children: "Included with this home"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    flexDirection: "column",
                    gap: "$12x",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            backgroundColor: "$backgroundSecondary",
                            padding: "$6x",
                            borderRadius: "$4x",
                            flexDirection: "row",
                            gap: "$4x",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    flexShrink: 0,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconTruckFilled/* default */.Z, {
                                        size: 24,
                                        color: (0,cjs.getToken)("$contentAccentBrand", "color")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexDirection: "column",
                                    gap: "$2x",
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: smallerThanMD ? "$labelSmall" : "$labelMedium",
                                            color: "$contentPrimary",
                                            children: "Early Move-In"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: smallerThanMD ? "$bodySmall" : "$bodyMedium",
                                            color: "$contentSecondary",
                                            children: "Move in up to 7 days early, helpful for scheduling movers and deliveries."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            backgroundColor: "$backgroundSecondary",
                            padding: "$6x",
                            borderRadius: "$4x",
                            flexDirection: "row",
                            gap: "$4x",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    flexShrink: 0,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconShieldLockFilled/* default */.Z, {
                                        size: 24,
                                        color: (0,cjs.getToken)("$contentAccentBrand", "color")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexDirection: "column",
                                    gap: "$2x",
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: smallerThanMD ? "$labelSmall" : "$labelMedium",
                                            color: "$contentPrimary",
                                            children: "100-Day Warranty"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: smallerThanMD ? "$bodySmall" : "$bodyMedium",
                                            color: "$contentSecondary",
                                            children: "Peace of mind with coverage on major systems and appliances for your first 100 days."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            backgroundColor: "$backgroundSecondary",
                            padding: "$6x",
                            borderRadius: "$4x",
                            flexDirection: "row",
                            gap: "$4x",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    flexShrink: 0,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M16.9756 3.54395C18.3563 3.54395 19.4756 4.66323 19.4756 6.04395V11.2588H11.8701L15.3633 7.7666C15.6561 7.4737 15.6562 6.99795 15.3633 6.70508C15.0704 6.41227 14.5946 6.41227 14.3018 6.70508L9.5293 11.4785C9.23642 11.7714 9.23646 12.2462 9.5293 12.5391L14.3018 17.3125C14.5947 17.6054 15.0704 17.6054 15.3633 17.3125C15.6561 17.0196 15.6562 16.5438 15.3633 16.251L11.8701 12.7588H19.4756V17.9834C19.4756 19.3641 18.3563 20.4834 16.9756 20.4834H7.02734C5.64663 20.4834 4.52734 19.3641 4.52734 17.9834V6.04395C4.52734 4.66323 5.64663 3.54395 7.02734 3.54395H16.9756Z",
                                            fill: "#0041E7"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexDirection: "column",
                                    gap: "$2x",
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: smallerThanMD ? "$labelSmall" : "$labelMedium",
                                            color: "$contentPrimary",
                                            children: "Free Cancellation"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: smallerThanMD ? "$bodySmall" : "$bodyMedium",
                                            color: "$contentSecondary",
                                            children: "If you don’t love your new home, cancel anytime before closing at no cost."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                width: "100%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
                    onPress: function() {
                        return setIsModalOpen(true);
                    },
                    "aria-label": "Open The Opendoor Guarantee details",
                    analyticsName: "marketplace-buy-with-confidence-button",
                    borderWidth: 1,
                    borderRadius: "$6x",
                    paddingTop: "$12x",
                    paddingRight: "$12x",
                    paddingBottom: "$12x",
                    paddingLeft: "$10x",
                    backgroundColor: "$backgroundPrimary",
                    flexDirection: "row",
                    gap: "$8x",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    width: "100%",
                    style: {
                        borderColor: "rgba(0, 65, 231, 0.3)",
                        background: "linear-gradient(0deg, rgba(0, 65, 231, 0.03) 0%, rgba(0, 65, 231, 0.03) 100%), var(--sem-color-background-primary, #FFF)",
                        boxShadow: "0 2px 12px 0 rgba(0, 65, 231, 0.04), 0 10px 22px 0 rgba(0, 65, 231, 0.04), 0 0 0 2px rgba(0, 65, 231, 0.10), 0 1px 6px 0 rgba(0, 65, 231, 0.20)"
                    },
                    "data-testid": "marketplace-buy-with-confidence-button",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            src: "https://images.opendoor.com/source/s3/imgdrop-production/2025-12-1764882992133-33358.png?preset=square-128&service=cosmos-cache-friendly&dpr=2",
                            alt: "Opendoor Guarantee"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            flexDirection: "column",
                            gap: "$2x",
                            alignItems: "flex-start",
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$labelMedium",
                                    color: "$contentPrimary",
                                    textAlign: "left",
                                    children: "The Opendoor Guarantee"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodySmall",
                                    color: "$contentSecondary",
                                    textAlign: "left",
                                    children: [
                                        "Included with this home.",
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "span",
                                            typography: "$bodySmall",
                                            color: "$contentSecondary",
                                            style: {
                                                borderBottom: "1px solid",
                                                borderColor: "currentColor",
                                                whiteSpace: "nowrap",
                                                display: "inline-block"
                                            },
                                            children: "Learn more"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            smallerThanMD ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomSheet, {
                isOpen: isModalOpen,
                onClose: function() {
                    return setIsModalOpen(false);
                },
                children: modalContent
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
                isOpen: isModalOpen,
                setIsOpen: setIsModalOpen,
                animation: "accelerateDecelerateFast",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                    title: "The Opendoor Guarantee",
                    description: "Included with every home",
                    hideTitle: true,
                    hideDescription: true,
                    children: modalContent
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/property/PropertySection/PropertyCTAs.tsx





var BuyDirectCTA = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1734).then(__webpack_require__.bind(__webpack_require__, 11734)).then(function(mod) {
        return mod.BuyDirectCTA;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11734)
            ];
        }
    },
    ssr: false
});
var PropertyCTAs = function(param) {
    var property = param.property;
    var ref = (0,propertyActionability/* determinePropertyActionability */.zf)(property), isActionable = ref.isActionable, tourKind = ref.tourKind, showBuyDirect = ref.showBuyDirect;
    if (!isActionable || !tourKind) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        tag: "menu",
        px: 0,
        mt: "$24x",
        mb: 0,
        gap: "$24x",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuyDirectCTA, {
                property: property
            }),
            showBuyDirect && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuyWithConfidence, {})
        ]
    });
};


/***/ }),

/***/ 20313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ PropertyDetails; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Divider/Divider.mjs
var Divider = __webpack_require__(11061);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(88111);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/TextButton.js
var TextButton = __webpack_require__(52007);
;// CONCATENATED MODULE: ./src/components/properties/shared/LongTextNew.tsx



var LongTextNew = function(param) {
    var content = param.content, limit = param.limit;
    var ref = (0,react.useState)(false), showAll = ref[0], setShowAll = ref[1];
    var handleOnPress = function() {
        setShowAll(function(prevShowAll) {
            return !prevShowAll;
        });
    };
    var label = showAll ? "Read less" : "Read more";
    if ((content === null || content === void 0 ? void 0 : content.length) <= limit) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            tag: "p",
            typography: "$bodyMedium",
            color: "$contentSecondary",
            children: content
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyMedium",
        color: "$contentSecondary",
        children: [
            showAll ? content : content.substring(0, limit) + "...",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
                analyticsName: "cosmos-long-text-read",
                "aria-label": label,
                onPress: handleOnPress,
                variant: "secondary",
                backgroundColor: "$transparent",
                size: "xsmall",
                label: label,
                mt: 8
            })
        ]
    });
};
/* harmony default export */ var shared_LongTextNew = (LongTextNew);

// EXTERNAL MODULE: ./src/components/marketplace/property/helpers.ts
var helpers = __webpack_require__(38298);
;// CONCATENATED MODULE: ./src/components/marketplace/property/HomeDetails.tsx







var convertKitchenCountertop = function(kitchenCountertop) {
    switch(kitchenCountertop){
        case "GRANITE_SLAB":
            return "Granite slab";
        case "GRANITE_TILE":
            return "Granite tile";
        case "QUARTZ":
            return "Quartz";
        case "CORIAN":
            return "Corian";
        case "FORMICA":
            return "Formica";
        default:
            return "Other";
    }
};
var convertMasterBedroomLocation = function(masterBedroomLocation, exteriorStories) {
    switch(masterBedroomLocation){
        case "FIRST_FLOOR":
            if (exteriorStories && exteriorStories > 1) {
                return "Downstairs bedroom";
            }
            return "Main bedroom";
        case "SECOND_FLOOR":
        case "THIRD_FLOOR":
            return "Upstairs bedroom";
        default:
            return null;
    }
};
var HomeDetails = function(param) {
    var property = param.property;
    var masterBedroomLocation = convertMasterBedroomLocation(property.masterBedroomLocation, property.exteriorStories);
    var ref;
    var rows = [
        {
            title: "Home type",
            value: (property === null || property === void 0 ? void 0 : property.dwellingType) ? (0,helpers/* convertDwellingType */.F)(property.dwellingType) : null
        },
        {
            title: "Lot size",
            value: (property === null || property === void 0 ? void 0 : property.sqFtLot) ? "".concat(property.sqFtLot.toLocaleString(), " sqft lot") : null
        },
        {
            title: "Price per sqft",
            value: (property === null || property === void 0 ? void 0 : property.pricePerSqFt) ? "".concat((0,currencyHelpers/* formatCurrency */.xG)(property.pricePerSqFt), " / sqft") : null
        },
        {
            title: "Built in",
            value: (ref = property === null || property === void 0 ? void 0 : property.yearBuilt) !== null && ref !== void 0 ? ref : null
        },
        {
            title: "Kitchen",
            value: (property === null || property === void 0 ? void 0 : property.kitchenCountertop) ? convertKitchenCountertop(property.kitchenCountertop) : null
        },
        {
            title: "Garage",
            value: (property === null || property === void 0 ? void 0 : property.garageSpaces) ? "".concat(property.garageSpaces, " car garage") : null
        },
        {
            title: "Master bedroom",
            value: masterBedroomLocation
        }, 
    ];
    var description = (0,react.useMemo)(function() {
        var filteredRows = rows.filter(function(row) {
            return row.value !== null;
        });
        var showPropertyDescription = property.listingState === "ON_THE_MARKET";
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            width: "100%",
            id: "homeDetails",
            children: [
                showPropertyDescription && (property === null || property === void 0 ? void 0 : property.description) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    $smallerThanMD: {
                        mb: 20
                    },
                    pb: 24,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_LongTextNew, {
                        content: property === null || property === void 0 ? void 0 : property.description,
                        limit: 212
                    })
                }),
                filteredRows.map(function(row, index) {
                    return row.value ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodySmall",
                                        color: "$contentPrimary",
                                        children: row.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelSmall",
                                        color: "$contentPrimary",
                                        children: row.value
                                    })
                                ]
                            }),
                            index !== filteredRows.length - 1 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                                my: 5
                            }) : null
                        ]
                    }, "homeDetail_".concat(index)) : null;
                }),
                (property === null || property === void 0 ? void 0 : property.sellerDisclosuresDownloadUrl) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                    label: "Download seller’s disclosure",
                    analyticsName: "seller_disclosure_link",
                    href: property.sellerDisclosuresDownloadUrl,
                    size: "small",
                    target: "_blank",
                    variant: "secondary",
                    mt: 24,
                    mb: 24
                })
            ]
        });
    }, [
        rows
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanLG: {
                    display: "none"
                },
                "data-testid": "marketplace-home-details-accordion-desktop",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
                    items: [
                        {
                            title: "Home details",
                            description: description
                        }, 
                    ],
                    variant: "medium",
                    size: "xlarge",
                    isFullWidth: true,
                    defaultOpen: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $largerThanMD: {
                    display: "none"
                },
                "data-testid": "marketplace-home-details-accordion-mobile",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
                    items: [
                        {
                            title: "Home details",
                            description: description
                        }, 
                    ],
                    variant: "medium",
                    size: "large",
                    isFullWidth: true,
                    defaultOpen: true
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/marketplace/property/PriceHistory.tsx







var PRICE_DENOMINATOR = 100;
var PriceHistory = function(param) {
    var listingHistory = param.listingHistory;
    // Dedupe by date after cleaning up timestamp format
    var listingHistoryByDateMap = (listingHistory === null || listingHistory === void 0 ? void 0 : listingHistory.reduce(function(map, history) {
        // ex: January 10, 2023
        var date = new Date(history.timestamp).toLocaleDateString("en-us", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
        if (!map[date]) {
            map[date] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, history), {
                timestamp: date
            });
        }
        return map;
    }, {})) || {};
    // Filter out events without any pricing data, and any marketplace specific events
    var pricingEvents = Object.values(listingHistoryByDateMap).filter(function(history) {
        return history.state !== "PRIVATELY_LISTED" && !(history.state === "SALE_PENDING" && !history.mls);
    }).filter(function(history) {
        return (history === null || history === void 0 ? void 0 : history.soldPriceCents) || (history === null || history === void 0 ? void 0 : history.currentListPriceCents) || (history === null || history === void 0 ? void 0 : history.originalListPriceCents);
    });
    var description = (0,react.useMemo)(function() {
        var ref;
        var rows = (ref = Object.values(pricingEvents)) === null || ref === void 0 ? void 0 : ref.map(function(history, index) {
            var price = ((history === null || history === void 0 ? void 0 : history.currentListPriceCents) || (history === null || history === void 0 ? void 0 : history.originalListPriceCents) || 0) / PRICE_DENOMINATOR;
            var state = history.state;
            if (state === "SOLD" || state === "OFF_MARKET") {
                price = ((history === null || history === void 0 ? void 0 : history.soldPriceCents) || (history === null || history === void 0 ? void 0 : history.currentListPriceCents) || 0) / PRICE_DENOMINATOR;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: index === pricingEvents.length - 1 ? 24 : 0,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodySmall",
                                        color: "$contentPrimary",
                                        children: history.timestamp
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodyXsmall",
                                        color: "$contentSecondary",
                                        textTransform: "capitalize",
                                        children: [
                                            state === null || state === void 0 ? void 0 : state.split("_").join(" ").toLowerCase(),
                                            history.mls && " \xb7 ".concat(history.mls)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "strong",
                                typography: "$labelSmall",
                                color: "$contentPrimary",
                                children: (0,currencyHelpers/* formatCurrency */.xG)(price)
                            })
                        ]
                    }),
                    index !== pricingEvents.length - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        my: 5
                    })
                ]
            }, history.timestamp);
        });
        if (!rows.length) {
            return "No price history";
        }
        return rows;
    }, [
        pricingEvents
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanLG: {
                    display: "none"
                },
                "data-testid": "marketplace-price-history-accordion-desktop",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
                    items: [
                        {
                            title: "Price history",
                            description: description
                        }, 
                    ],
                    variant: "medium",
                    size: "xlarge",
                    isFullWidth: true,
                    defaultOpen: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $largerThanMD: {
                    display: "none"
                },
                "data-testid": "marketplace-price-history-accordion-mobile",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
                    items: [
                        {
                            title: "Price history",
                            description: description
                        }, 
                    ],
                    variant: "medium",
                    size: "large",
                    isFullWidth: true,
                    defaultOpen: true
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/property/Schools.tsx
var Schools = __webpack_require__(36523);
;// CONCATENATED MODULE: ./src/components/marketplace/property/PropertySection/PropertyDetails.tsx






var PropertyDetails = function(param) {
    var property = param.property;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "section",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomeDetails, {
                        property: property
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        mt: 16,
                        mb: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "section",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Schools/* Schools */.A, {
                        schools: property === null || property === void 0 ? void 0 : property.schools,
                        schoolDistricts: property === null || property === void 0 ? void 0 : property.schoolDistricts
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        mt: 16,
                        mb: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "section",
                children: [
                    (property === null || property === void 0 ? void 0 : property.listingHistory) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceHistory, {
                        listingHistory: property.listingHistory
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        mt: 16,
                        mb: 40
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 46609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ PropertyStatus; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53757);


var DisplayStateStatusMap = {
    TEMP_UNAVAILABLE: "Temporarily unavailable",
    AVAILABLE_SOON: "Available soon",
    IN_CONTRACT: "In contract",
    RECENTLY_SOLD: "Sold",
    ON_THE_MARKET: undefined,
    IS_EXCLUSIVE: undefined,
    TRADITIONAL: undefined,
    UNKNOWN: undefined
};
var PropertyStatus = function(param) {
    var property = param.property;
    if (!(property === null || property === void 0 ? void 0 : property.listingState) || !DisplayStateStatusMap[property === null || property === void 0 ? void 0 : property.listingState]) return null;
    var ref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        mb: "$12x",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .D, {
            // empty string done for typescript, will never reach that case
            label: (ref = DisplayStateStatusMap[property === null || property === void 0 ? void 0 : property.listingState]) !== null && ref !== void 0 ? ref : "",
            rounded: true,
            size: "medium",
            $smallerThanMD: {
                size: "small"
            },
            weight: "regularWeight"
        })
    });
};


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PropertySummary; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61532);
/* harmony import */ var _opendoor_shared_fe_formatUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64260);
/* harmony import */ var components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95707);
/* harmony import */ var _Pricing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79338);





var PropertySummary = function(param) {
    var property = param.property;
    var ref;
    var formattedStreet = (0,components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_1__/* .formatStreetAddress */ .Dm)(property.street, property.unitType, property.unitNumber);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        tag: "hgroup",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-start",
                pb: 24,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        tag: "h1",
                        typography: "$subheaderLarge",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                $largerThanSM: {
                                    typography: "$subheaderLarge"
                                },
                                tag: "span",
                                typography: "$subheaderSmall",
                                fontWeight: "$medium",
                                children: formattedStreet
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                $largerThanSM: {
                                    typography: "$subheaderLarge"
                                },
                                tag: "span",
                                typography: "$subheaderSmall",
                                fontWeight: "$medium",
                                color: "$contentTertiary",
                                children: [
                                    property.city,
                                    ", ",
                                    property.state,
                                    " ",
                                    property.zip
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                        backgroundColor: "$backgroundPrimary",
                        borderWidth: 1,
                        borderColor: "$borderPrimary",
                        borderRadius: "$8x",
                        paddingHorizontal: 13,
                        paddingVertical: 13,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .FavoriteButton */ ._6, {
                            analyticsName: "cosmos-marketplace-pdp-favorite",
                            onPress: property.onClickReaction,
                            size: "large",
                            variant: "default",
                            isFavorited: property.isLiked
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                tag: "section",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_Pricing__WEBPACK_IMPORTED_MODULE_2__/* .PricingTraditional */ .n, {
                        listPrice: property === null || property === void 0 ? void 0 : property.listPrice
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                        flexDirection: "row",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentTertiary",
                                children: [
                                    property.bedrooms,
                                    " bds"
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentTertiary",
                                mx: 8,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentTertiary",
                                children: [
                                    property.bathrooms,
                                    " ba"
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentTertiary",
                                mx: 8,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentTertiary",
                                children: [
                                    property.sqFtTotalLiving,
                                    " sqft"
                                ]
                            }),
                            (property === null || property === void 0 ? void 0 : property.estimatedMonthlyPayment) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                        tag: "span",
                                        typography: "$bodyMedium",
                                        color: "$contentTertiary",
                                        mx: 8,
                                        children: "\xb7"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                        tag: "p",
                                        typography: "$bodyMedium",
                                        color: "$contentTertiary",
                                        children: "".concat((0,_opendoor_shared_fe_formatUtils__WEBPACK_IMPORTED_MODULE_0__/* .formatCurrency */ .xG)(property === null || property === void 0 ? void 0 : property.estimatedMonthlyPayment), "/month est.")
                                    })
                                ]
                            })
                        ]
                    }),
                    !!(property === null || property === void 0 ? void 0 : (ref = property.schoolDistricts) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                        flexDirection: "row",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                            tag: "span",
                            typography: "$bodyMedium",
                            color: "$contentTertiary",
                            pt: "$2x",
                            children: property.schoolDistricts.join(" & ")
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 50891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TourWithAgentModal; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60179);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2267);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64370);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79384);
/* harmony import */ var components_helpers_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98417);
/* harmony import */ var components_marketplace_helpers_useTrackProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97997);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77997);







function getShareableContent(slug, addressToken) {
    return "Check out this home I want to tour from Opendoor!\n\n".concat(getShareableLink(slug, addressToken));
}
function getShareableLink(slug, addressToken) {
    return "www.opendoor.com".concat((0,components_helpers_links__WEBPACK_IMPORTED_MODULE_3__/* .corePdpLink */ .v)(slug, addressToken));
}
function getEmailLink(slug, addressToken) {
    return "mailto:?body=".concat(encodeURIComponent(getShareableContent(slug, addressToken)));
}
var PRESS_SCALE = 0.98;
var TOAST_DURATION = 1000; // 1 second
var TourWithAgentModal = function(param) {
    var property = param.property, isOpen = param.isOpen, onClose = param.onClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isToastOpen = ref[0], setIsToastOpen = ref[1];
    var trackProperty = (0,components_marketplace_helpers_useTrackProperty__WEBPACK_IMPORTED_MODULE_1__/* .useTrackProperty */ .a)().trackProperty;
    var trackJourneyEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_2__/* .useObservability */ .C3)().trackJourneyEvent;
    var copyToClipboard = function(text) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
        }
    };
    var handleOnShare = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        trackProperty("property-share", "marketplace-pdp-tour-with-agent-copy");
        if (property.addressToken) {
            trackJourneyEvent("marketplaceProperty", "share", {
                addressUuid: property.addressToken,
                source: "copy"
            });
        }
        copyToClipboard(getShareableLink(property.slug, property.addressToken));
        setIsToastOpen(true);
        onClose();
    }, []);
    var handleEmail = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        trackProperty("property-share", "marketplace-pdp-tour-with-agent-email");
        trackJourneyEvent("marketplaceProperty", "share", {
            addressUuid: property.addressToken,
            source: "email"
        });
        window.open(getEmailLink(property.slug, property.addressToken), "_self");
    }, []);
    var closeToast = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsToastOpen(false);
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Dialog */ .V, {
                isOpen: isOpen,
                analyticsName: "marketplace-tour-with-agent-modal",
                trackImpression: true,
                setIsOpen: onClose,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Dialog.Content */ .V.Content, {
                        title: "Tour with an agent",
                        description: "Share this home with your agent. They need to get the access codes or lockbox info to tour.",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                            $smallerThanMD: {
                                width: "100%"
                            },
                            $largerThanSM: {
                                width: 600
                            },
                            p: 30,
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .PressableBox */ .K, {
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    onPress: handleOnShare,
                                    analyticsName: "tour-with-agent-copy",
                                    "aria-label": "Copy to clipboard",
                                    alignItems: "center",
                                    borderColor: "$borderSecondary",
                                    borderBottomWidth: 1,
                                    py: 24,
                                    mx: 32,
                                    pressStyle: {
                                        scale: PRESS_SCALE
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .x, {
                                            tag: "span",
                                            typography: "$bodySmall",
                                            children: "Copy link"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ContentCopyIcon, {
                                            size: 16
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .PressableBox */ .K, {
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    onPress: handleEmail,
                                    analyticsName: "tour-with-agent-email",
                                    "aria-label": "Share in Email",
                                    alignItems: "center",
                                    py: 24,
                                    mx: 32,
                                    pressStyle: {
                                        scale: PRESS_SCALE
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .x, {
                                            tag: "span",
                                            typography: "$bodySmall",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            size: 16
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Dialog.Actions */ .V.Actions, {
                        buttonOneProps: {
                            analyticsName: "tour-with-agent-close",
                            label: "Close",
                            variant: "primary",
                            onPress: onClose,
                            pressStyle: {
                                scale: PRESS_SCALE
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Toast */ .F, {
                analyticsName: "tour-with-agent-copy-link-toast-success",
                duration: TOAST_DURATION,
                isOpen: isToastOpen,
                message: "Link copied to clipboard",
                onClose: closeToast,
                isSuccess: true
            })
        ]
    });
};
function ContentCopyIcon(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("mask", {
                id: "path-1-inside-1_3070_193338",
                fill: "white",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("rect", {
                    x: "0.5",
                    y: "3.5",
                    width: "12.5",
                    height: "16.25",
                    rx: "1.25"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("rect", {
                x: "0.5",
                y: "3.5",
                width: "12.5",
                height: "16.25",
                rx: "1.25",
                stroke: "black",
                strokeWidth: "3.75",
                mask: "url(#path-1-inside-1_3070_193338)"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("path", {
                d: "M4.25 1H14.25C14.9404 1 15.5 1.55964 15.5 2.25V16",
                stroke: "black",
                strokeWidth: "1.875"
            })
        ]
    });
}


/***/ }),

/***/ 36523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Schools; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88111);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11061);




var Schools = function(param) {
    var disclaimer = param.disclaimer, schools = param.schools, schoolDistricts = param.schoolDistricts, summary = param.summary;
    var elementarySchoolDistrict = schoolDistricts === null || schoolDistricts === void 0 ? void 0 : schoolDistricts.filter(function(district) {
        return !district.toLowerCase().includes("high");
    })[0];
    var ref;
    var highSchoolDistrict = (ref = schoolDistricts === null || schoolDistricts === void 0 ? void 0 : schoolDistricts.filter(function(district) {
        return district.toLowerCase().includes("high");
    })[0]) !== null && ref !== void 0 ? ref : elementarySchoolDistrict;
    var description = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - open attribute is not in the Box component
        /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
            children: [
                summary && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    tag: "p",
                    typography: "$bodySmall",
                    color: "$contentPrimary",
                    mb: 24,
                    children: summary
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                    flexDirection: "column",
                    children: [
                        !!(schoolDistricts === null || schoolDistricts === void 0 ? void 0 : schoolDistricts.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                            tag: "span",
                            typography: "$labelXsmall",
                            color: "$contentSecondary",
                            my: 12,
                            children: "School districts"
                        }),
                        elementarySchoolDistrict && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$bodySmall",
                                            color: "$contentPrimary",
                                            children: "Elementary"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$labelSmall",
                                            color: "$contentPrimary",
                                            children: elementarySchoolDistrict
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    my: 5
                                })
                            ]
                        }),
                        highSchoolDistrict && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$bodySmall",
                                            color: "$contentPrimary",
                                            children: "High School"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$labelSmall",
                                            color: "$contentPrimary",
                                            children: highSchoolDistrict
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    my: 5
                                })
                            ]
                        }),
                        (schools === null || schools === void 0 ? void 0 : schools.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                            tag: "span",
                            typography: "$labelXsmall",
                            color: "$contentSecondary",
                            my: 12,
                            children: "Schools"
                        }),
                        schools === null || schools === void 0 ? void 0 : schools.map(function(school, index) {
                            var ref;
                            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        mb: index === schools.length - 1 ? 24 : 0,
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                                tag: "p",
                                                typography: "$bodySmall",
                                                color: "$contentPrimary",
                                                textTransform: "capitalize",
                                                children: school === null || school === void 0 ? void 0 : (ref = school.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                                tag: "p",
                                                typography: "$labelSmall",
                                                color: "$contentPrimary",
                                                children: (school === null || school === void 0 ? void 0 : school.rating) ? "".concat(school.rating, " / 10") : "N/A"
                                            })
                                        ]
                                    }),
                                    index !== schools.length - 1 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        my: 5
                                    })
                                ]
                            }, school.id);
                        })
                    ]
                }),
                disclaimer && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                        tag: "p",
                        typography: "$labelXsmall",
                        color: "$contentStateInactivePrimary",
                        children: disclaimer
                    })
                })
            ]
        });
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                $smallerThanLG: {
                    display: "none"
                },
                "data-testid": "marketplace-schools-accordion-desktop",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Accordion */ .U, {
                    items: [
                        {
                            title: "Schools",
                            description: description
                        }, 
                    ],
                    variant: "medium",
                    size: "xlarge",
                    isFullWidth: true,
                    defaultOpen: true
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                $largerThanMD: {
                    display: "none"
                },
                "data-testid": "marketplace-schools-accordion-mobile",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Accordion */ .U, {
                    items: [
                        {
                            title: "Schools",
                            description: description
                        }, 
                    ],
                    variant: "medium",
                    size: "large",
                    isFullWidth: true,
                    defaultOpen: true
                })
            })
        ]
    });
};


/***/ }),

/***/ 72199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SimilarListings; },
/* harmony export */   "d": function() { return /* binding */ ListingCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25923);
/* harmony import */ var _opendoor_cinderblocks_marketplace_PropertyCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36916);
/* harmony import */ var components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95707);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35480);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38298);









// This hook is used to lazy load the photo URL when the component is in view
// It uses the Intersection Observer API to detect when the component is in the viewport
// and sets the photo URL to be loaded only then
// This helps in optimizing performance by not loading images that are not visible to the user
// and reduces the initial load time of the component
var useLazyLoadPhoto = function(photoUrl) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!containerRef.current || isLoaded) return;
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setIsLoaded(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        isLoaded
    ]);
    return {
        containerRef: containerRef,
        loadedPhotoUrl: isLoaded ? photoUrl : null
    };
};
var ListingCard = function(param) {
    var utmSource = param.utmSource, utmMedium = param.utmMedium, utmCampaign = param.utmCampaign, utmContent = param.utmContent, utmTerm = param.utmTerm, listing = param.listing;
    var ref;
    var ref1 = (0,components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_2__/* .usePropertyReactions */ .O8)(listing === null || listing === void 0 ? void 0 : listing.addressToken, "REACTION_SOURCE_WEB_PDP"), isLiked = ref1.isLiked, onClickReaction = ref1.onClickReaction;
    var photoUrl = "".concat(listing === null || listing === void 0 ? void 0 : (ref = listing.photos) === null || ref === void 0 ? void 0 : ref[0], "?").concat(new URLSearchParams({
        service: "cosmos",
        preset: "3:2-md",
        presetScale: "2/3",
        dpr: "1"
    }).toString()) || null;
    var ref2 = useLazyLoadPhoto(photoUrl), containerRef = ref2.containerRef, loadedPhotoUrl = ref2.loadedPhotoUrl;
    var ref3;
    var link = "".concat(_globals__WEBPACK_IMPORTED_MODULE_3__/* .COSMOS_URL */ .EQ, "/properties/").concat((ref3 = listing === null || listing === void 0 ? void 0 : listing.slug) !== null && ref3 !== void 0 ? ref3 : "_", "/aid_").concat(listing === null || listing === void 0 ? void 0 : listing.addressToken, "?").concat(new URLSearchParams((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, utmSource && {
        utm_source: utmSource
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmContent && {
        utm_content: utmContent
    }, utmTerm && {
        utm_term: utmTerm
    })).toString());
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_cinderblocks_marketplace_PropertyCard__WEBPACK_IMPORTED_MODULE_1__/* .PropertyCard */ .J, {
            baths: listing === null || listing === void 0 ? void 0 : listing.baths,
            beds: listing === null || listing === void 0 ? void 0 : listing.beds,
            city: listing === null || listing === void 0 ? void 0 : listing.city,
            dwellingType: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .convertDwellingType */ .F)(listing === null || listing === void 0 ? void 0 : listing.dwellingType),
            estimatedMonthlyPayment: listing === null || listing === void 0 ? void 0 : listing.estimatedMonthlyPayment,
            href: link,
            isFavorite: isLiked,
            neighborhood: listing === null || listing === void 0 ? void 0 : listing.neighborhood,
            onFavoritePress: onClickReaction,
            photoUrl: loadedPhotoUrl,
            price: listing === null || listing === void 0 ? void 0 : listing.listPrice,
            sqft: listing === null || listing === void 0 ? void 0 : listing.livingSquareFootage
        })
    });
};
var DISPLAYED_LISTING_SET_COUNT = 6;
var SimilarListings = function(param) {
    var listings = param.listings, title = param.title, utmSource = param.utmSource, utmMedium = param.utmMedium, utmCampaign = param.utmCampaign, utmContent = param.utmContent, utmTerm = param.utmTerm;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(DISPLAYED_LISTING_SET_COUNT), 2), displayedListingCount = ref[0], setDisplayedListingCount = ref[1];
    var incrementDisplayedListingCount = function() {
        setDisplayedListingCount(function(prev) {
            return prev + DISPLAYED_LISTING_SET_COUNT;
        });
    };
    var similarListings = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return listings.filter(function(_, index) {
            return index < displayedListingCount;
        }).map(function(listing, index) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                mb: 24,
                $largerThanXS: {
                    width: "100%"
                },
                $largerThanSM: {
                    width: "100%"
                },
                $largerThanMD: {
                    width: "48%"
                },
                $largerThanLG: {
                    width: "48%"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ListingCard, {
                    listing: listing,
                    utmSource: utmSource,
                    utmMedium: utmMedium,
                    utmCampaign: utmCampaign,
                    utmContent: utmContent,
                    utmTerm: utmTerm
                })
            }, index);
        });
    }, [
        listings,
        displayedListingCount
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        flexDirection: "column",
        $smallerThanMD: {
            paddingBottom: "$62x"
        },
        $largerThanSM: {
            paddingBottom: "$12x"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                tag: "h5",
                typography: "$subheaderXsmall",
                color: "$contentPrimary",
                mb: "$12x",
                children: title || "Similar listings"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                flexWrap: "wrap",
                justifyContent: "space-between",
                $largerThanXS: {
                    flexDirection: "column"
                },
                $largerThanSM: {
                    flexDirection: "column"
                },
                $largerThanMD: {
                    flexDirection: "row"
                },
                $largerThanLG: {
                    flexDirection: "row"
                },
                children: similarListings
            }),
            displayedListingCount < listings.length && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                onPress: incrementDisplayedListingCount,
                variant: "secondary",
                size: "small",
                analyticsName: "marketplace-show-more-listings",
                label: "See more homes"
            })
        ]
    });
};


/***/ }),

/***/ 38298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ convertDwellingType; }
/* harmony export */ });
/* unused harmony export formatPrettyTimeRange */
var TWELVE_HOURS = 12;
var convertDwellingType = function(dwellingType) {
    switch(dwellingType){
        case "SINGLE_FAMILY":
            return "Single family";
        case "TOWNHOUSE":
            return "Townhouse";
        case "CONDO":
            return "Condo";
        case "MULTI_FAMILY":
            return "Multi family";
        case "OTHER":
            return "Other";
        default:
            return "Other";
    }
};
var formatHours = function(date) {
    var hour = date.getHours();
    var isAm = hour < TWELVE_HOURS;
    if (hour > TWELVE_HOURS) {
        hour -= TWELVE_HOURS;
    }
    var openSuffix = isAm ? "AM" : "PM";
    return "".concat(hour).concat(openSuffix);
};
var formatPrettyTimeRange = function(start, end) {
    var weekday = start.toLocaleDateString([], {
        weekday: "short"
    });
    var month = start.toLocaleDateString([], {
        month: "short"
    });
    var date = start.getDate();
    var startTime = formatHours(start);
    var endTime = formatHours(end);
    return "".concat(weekday, " ").concat(month, " ").concat(date, ", ").concat(startTime, " - ").concat(endTime);
};


/***/ }),

/***/ 19585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vf": function() { return /* reexport */ FooterCTA; },
  "Ub": function() { return /* reexport */ GalleryPhotos; },
  "ey": function() { return /* reexport */ Lightbox_Lightbox; },
  "dF": function() { return /* reexport */ SimilarListings/* ListingCard */.d; },
  "D5": function() { return /* reexport */ Map; },
  "cS": function() { return /* reexport */ PhotoCarousel_PhotoCarousel; },
  "qH": function() { return /* reexport */ PropertySection; },
  "V8": function() { return /* reexport */ ShareModal; },
  "Cd": function() { return /* reexport */ SimilarListings/* SimilarListings */.C; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/components/self-tour/hooks/useTouring.tsx
var useTouring = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/marketplace/property/PropertySection/FloatingCTA.tsx


var FloatingCTA = function(param) {
    var ctaText = param.ctaText, onClickCta = param.onClickCta, ctaHref = param.ctaHref, isLiked = param.isLiked, onClickReaction = param.onClickReaction, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _showSecondaryButton = param.showSecondaryButton, showSecondaryButton = _showSecondaryButton === void 0 ? false : _showSecondaryButton, secondaryButtonText = param.secondaryButtonText, secondaryButtonHref = param.secondaryButtonHref, onClickSecondary = param.onClickSecondary;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    , {
        // @ts-ignore
        position: "sticky",
        zIndex: 4,
        bottom: 0,
        width: "100%",
        $smallerThanMD: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            position: "fixed",
            paddingHorizontal: "$6x",
            paddingBottom: "$6x"
        },
        $largerThanSM: {
            paddingHorizontal: "$12x",
            paddingBottom: "$12x"
        },
        style: {
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
            pointerEvents: isVisible ? "auto" : "none"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            backgroundColor: "$backgroundPrimary",
            borderRadius: "$12x",
            borderWidth: 0.5,
            borderColor: "$borderStateHoverTertiary",
            shadow: "$pressed",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* FavoriteButton */._6, {
                    analyticsName: "cosmos-marketplace-pdp-favorite",
                    onPress: onClickReaction,
                    size: "medium",
                    variant: "default",
                    ml: 16,
                    my: 12,
                    isFavorited: isLiked
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    flexDirection: "row",
                    gap: "$4x",
                    alignItems: "center",
                    mr: 12,
                    my: 12,
                    children: [
                        showSecondaryButton && secondaryButtonText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            analyticsName: "cosmos-marketplace-footer-secondary-cta",
                            "aria-label": secondaryButtonText,
                            variant: "secondary",
                            size: "small",
                            onPress: onClickSecondary,
                            label: secondaryButtonText,
                            href: secondaryButtonHref,
                            target: "_blank",
                            rel: "noopener"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            analyticsName: "cosmos-marketplace-footer-cta",
                            "aria-label": ctaText,
                            variant: variant,
                            size: "small",
                            onPress: onClickCta,
                            label: ctaText,
                            href: ctaHref,
                            target: "_blank",
                            rel: "noopener",
                            disabled: disabled
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/TourWithAgentModal.tsx
var TourWithAgentModal = __webpack_require__(50891);
;// CONCATENATED MODULE: ./src/components/marketplace/property/FooterCTA.tsx




var FooterCTA = function(param) {
    var property = param.property, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible;
    var touringInfo = (0,useTouring/* useTouring */.f)(property, {
        placement: "footer"
    });
    // Only show FooterCTA for actionable properties
    if (!touringInfo) {
        return null;
    }
    var primaryAction = touringInfo.primaryAction, secondaryAction = touringInfo.secondaryAction, tourKind = touringInfo.tourKind, isDialogOpen = touringInfo.isDialogOpen, closeDialog = touringInfo.closeDialog;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingCTA, {
                ctaText: primaryAction.text,
                onClickCta: primaryAction.onClick,
                ctaHref: primaryAction.href,
                isLiked: property.isLiked,
                onClickReaction: property.onClickReaction,
                variant: primaryAction.variant,
                isVisible: isVisible,
                disabled: primaryAction.disabled,
                showSecondaryButton: !!secondaryAction,
                secondaryButtonText: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.text,
                secondaryButtonHref: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.href,
                onClickSecondary: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.onClick
            }),
            tourKind === "tourWithAgent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TourWithAgentModal/* TourWithAgentModal */.D, {
                property: property,
                isOpen: isDialogOpen,
                onClose: closeDialog
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/Lightbox.js + 2 modules
var Lightbox = __webpack_require__(73503);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 4 modules
var helpers = __webpack_require__(95707);
;// CONCATENATED MODULE: ./src/components/marketplace/property/Lightbox.tsx







var Lightbox_Lightbox = function(param) {
    var handleClose = param.handleClose, isOpen = param.isOpen, property = param.property, selectedPhotoIndex = param.selectedPhotoIndex;
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    var displayPrice = "Price not available";
    if ((0,helpers/* isBuyDirectEligible */.pX)(property) && property.displayBadge === "ON_THE_MARKET" && property.buyDirectPrice) {
        displayPrice = (0,currencyHelpers/* formatCurrency */.xG)(property.buyDirectPrice);
    } else if (property === null || property === void 0 ? void 0 : property.listPrice) {
        displayPrice = (0,currencyHelpers/* formatCurrency */.xG)(property.listPrice);
    }
    var LightboxHeader = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$labelMedium",
                    color: "$contentInversePrimary",
                    children: displayPrice
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$bodyXsmall",
                    color: "$contentInversePrimary",
                    ml: "$2x",
                    children: formattedStreet
                })
            ]
        });
    }, [
        property
    ]);
    var LightboxFooter = (0,react.useMemo)(function() {
        var ref;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            flexDirection: "row",
            justifyContent: "space-between",
            pt: "$4x",
            px: "$12x",
            $smallerThanMD: {
                display: "none"
            },
            width: "100%",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$labelMedium",
                            color: "$contentInversePrimary",
                            children: displayPrice
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodyMedium",
                            color: "$contentInversePrimary",
                            ml: "$2x",
                            children: [
                                "— ",
                                formattedStreet,
                                ", ",
                                property.city,
                                ", ",
                                property.state,
                                " ",
                                property.zip
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    alignSelf: "flex-end",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* FavoriteButton */._6, {
                            analyticsName: "cosmos-marketplace-pdp-lightbox-favorite-property-button",
                            onPress: property === null || property === void 0 ? void 0 : property.onClickReaction,
                            size: "medium",
                            variant: "inverse",
                            mx: "$12x",
                            isFavorited: (ref = property === null || property === void 0 ? void 0 : property.isLiked) !== null && ref !== void 0 ? ref : false
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TourButton, {
                            property: property
                        })
                    ]
                })
            ]
        });
    }, [
        property
    ]);
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Lightbox/* Lightbox */.e, {
        analyticsName: "cosmos-marketplace-property-photo-lightbox",
        footer: LightboxFooter,
        handleClose: handleClose,
        isOpen: isOpen,
        mobileTitle: LightboxHeader,
        photoUrls: (ref = property === null || property === void 0 ? void 0 : property.photos) !== null && ref !== void 0 ? ref : [],
        selectedPhotoIndex: selectedPhotoIndex
    });
};
var TourButton = function(param) {
    var property = param.property;
    var touringInfo = (0,useTouring/* useTouring */.f)(property, {
        placement: "lightbox"
    });
    if (!touringInfo) return null;
    var primaryAction = touringInfo.primaryAction, secondaryAction = touringInfo.secondaryAction, tourKind = touringInfo.tourKind, closeDialog = touringInfo.closeDialog, isDialogOpen = touringInfo.isDialogOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            secondaryAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: secondaryAction.analyticsName,
                label: secondaryAction.text,
                onPress: secondaryAction.onClick,
                href: secondaryAction.href,
                target: secondaryAction.target,
                size: "small",
                variant: secondaryAction.variant,
                disabled: secondaryAction.disabled,
                mr: "$2x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: primaryAction.analyticsName,
                label: primaryAction.text,
                onPress: primaryAction.onClick,
                href: primaryAction.href,
                target: primaryAction.target,
                size: "small",
                variant: primaryAction.variant,
                disabled: primaryAction.disabled
            }),
            tourKind === "tourWithAgent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TourWithAgentModal/* TourWithAgentModal */.D, {
                property: property,
                isOpen: isDialogOpen,
                onClose: closeDialog
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.css
var mapbox_gl = __webpack_require__(7609);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/shared/dynamic/index.tsx





/**
 * Load a component by:
 *   1. Waiting for a condition to be true
 *   2. Kicking off it's dynamic promise at that time
 *
 * The default dynamic import from next/dynamic only sort-of saves bundle size
 * but it still contributes a lot to active parsing time.
 */ function DynamicComponentWithCondition(props) {
    var ref = (0,react.useState)(null), LoadableComponent = ref[0], setLoadableComponent = ref[1];
    (0,react.useEffect)(function() {
        if (!props.loadingCondition) {
            return;
        }
        setLoadableComponent(dynamic_default()(props.dynamicLoaderFunction, {
            ssr: false
        }));
    }, [
        props.loadingCondition
    ]);
    var componentProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        dynamicLoaderFunction: undefined,
        loadingCondition: undefined
    });
    return props.loadingCondition && LoadableComponent ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadableComponent, (0,_object_spread/* default */.Z)({}, componentProps)) : // eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

// EXTERNAL MODULE: ./src/components/shared/hooks/useInView.tsx
var useInView = __webpack_require__(53456);
;// CONCATENATED MODULE: ./src/components/marketplace/property/Map.tsx






var Map = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,useInView/* useInViewAfterLoad */.D)({
        triggerOnce: true,
        initialInView: true,
        ref: ref
    }), inViewMapPage = ref1.inView;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        height: "100%",
        width: "100%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicComponentWithCondition, {
            dynamicLoaderFunction: function() {
                return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9323)]).then(__webpack_require__.bind(__webpack_require__, 69323)).then(function(mod) {
                    return mod.default;
                });
            },
            loadingCondition: inViewMapPage,
            latitude: latitude,
            longitude: longitude
        })
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/property/SimilarListings.tsx
var SimilarListings = __webpack_require__(72199);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/breakpoints.mjs
var breakpoints = __webpack_require__(64863);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var useTrackProperty = __webpack_require__(97997);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(29212);
;// CONCATENATED MODULE: ./src/components/marketplace/property/media/GalleryPhotos.tsx








var GALLERY_SOURCE_SET_CONFIG = [
    {
        minWidth: breakpoints/* breakpoints.2 */.AV[2],
        maxWidth: breakpoints/* breakpoints.3 */.AV[3],
        preset: "3:2-md",
        presetScale: "2/3"
    },
    {
        minWidth: breakpoints/* breakpoints.3 */.AV[3],
        maxWidth: 1400,
        preset: "3:2-lg",
        presetScale: "3/4"
    },
    {
        minWidth: 1400,
        maxWidth: null,
        preset: "3:2-xl",
        presetScale: "1"
    }, 
];
var GalleryPhoto = function(param) {
    var photoUrl = param.photoUrl, idx = param.idx, toggleLightbox = param.toggleLightbox, setSelectedPhotoIndex = param.setSelectedPhotoIndex, isLastPhoto = param.isLastPhoto;
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var handleClick = function() {
        trackProperty("property-images", "marketplace-pdp-lightbox");
        toggleLightbox();
        setSelectedPhotoIndex(idx);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
        analyticsName: "cosmos-marketplace-property-desktop-gallery-photo",
        "aria-label": "property photo ".concat(idx + 1),
        mb: isLastPhoto ? 0 : 4,
        py: 0,
        px: 0,
        onPress: handleClick,
        width: "100%",
        children: (0,pictures/* generatePresetPictureSet */.eY)({
            debugImageSizes: false,
            photoUrl: photoUrl,
            sizes: GALLERY_SOURCE_SET_CONFIG,
            radii: {},
            lazy: idx !== 0
        })
    }, "".concat(idx, "-photo"));
};
var GalleryPhotos = function(param) {
    var property = param.property, toggleLightbox = param.toggleLightbox, handleSetSelectedPhotoIndex = param.handleSetSelectedPhotoIndex;
    var Gallery = (0,react.useMemo)(function() {
        var ref;
        var photos = property === null || property === void 0 ? void 0 : (ref = property.photos) === null || ref === void 0 ? void 0 : ref.map(function(photo, idx) {
            var ref, ref1;
            var galleryPhoto = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GalleryPhoto, {
                idx: idx,
                photoUrl: photo,
                toggleLightbox: toggleLightbox,
                setSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                isLastPhoto: idx === (((ref = property.photos) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = property.photos) === null || ref1 === void 0 ? void 0 : ref1.length) - 1)
            }, idx);
            if (idx == 1) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    flexDirection: "row",
                    mb: 4,
                    justifyContent: "space-between",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            width: "49.75%",
                            height: "100%",
                            aspectRatio: 16 / 9,
                            overflow: "hidden",
                            children: galleryPhoto
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            width: "49.75%",
                            aspectRatio: 16 / 9,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Map, {
                                latitude: property.latitude,
                                longitude: property.longitude
                            }, "property-location")
                        })
                    ]
                }, "split-photo-map-view");
            }
            return galleryPhoto;
        });
        return photos;
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        height: "100vh",
        $smallerThanMD: {
            display: "none",
            overflow: "hidden"
        },
        $largerThanMD: {
            flexBasis: "50%",
            overflow: "scroll"
        },
        $smallerThanLG: {
            flexBasis: "50%",
            overflow: "scroll"
        },
        $largerThanLG: {
            flex: 1
        },
        alignItems: "center",
        mt: 55,
        width: "100%",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;// IE and Edge\n        scrollbar-width:none;// Firefox"),
        children: Gallery
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarousel.js + 1 modules
var PhotoCarousel = __webpack_require__(29434);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box_Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button_Button = __webpack_require__(26029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Divider/Divider.mjs
var Divider = __webpack_require__(11061);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/hooks/useMedia.mjs + 1 modules
var useMedia = __webpack_require__(61151);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODTheme.mjs + 39 modules
var ODTheme = __webpack_require__(56536);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconX.mjs
var IconX = __webpack_require__(77373);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text_Text = __webpack_require__(4796);
;// CONCATENATED MODULE: ./src/components/marketplace/property/media/Modal/NavigationBar.tsx





var getNavigationBarTitleId = function(props) {
    return "".concat(props.id || "navigation-bar", "-title");
};
var NavigationBar = function(param) {
    var id = param.id, title = param.title, titleProps = param.titleProps, subtitle = param.subtitle, rightComponent = param.rightComponent, subtitleProps = param.subtitleProps, leftComponent = param.leftComponent;
    var hasTitle = !!title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        bgColor: "neutrals0",
        py: [
            "14px"
        ],
        pl: [
            "24px",
            null,
            "30px",
            "40px"
        ],
        pr: "18px",
        flex: "1 1 auto",
        alignItems: "center",
        justifyContent: "flex-start",
        id: id,
        zIndex: 2000,
        children: [
            leftComponent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                justifySelf: "flex-start",
                flexBasis: hasTitle ? "50%" : "auto",
                justifyContent: "flex-start",
                alignItems: "center",
                flexShrink: 2,
                minWidth: hasTitle ? "auto" : 0,
                children: leftComponent
            }),
            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                flexDirection: "column",
                flexBasis: "100%",
                flexShrink: 1,
                minWidth: 0,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        size: "s1",
                        fontWeight: [
                            "semibold"
                        ],
                        // @ts-expect-error letter-spacing is now tokenized in bricks
                        letterSpacing: "-0.03em",
                        whiteSpace: "nowrap",
                        as: "h1",
                        mb: "0",
                        id: getNavigationBarTitleId({
                            id: id
                        }),
                        textOverflow: "ellipsis",
                        overflow: "hidden"
                    }, titleProps), {
                        children: title
                    })),
                    subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        size: "s2",
                        fontWeight: "regular",
                        // @ts-expect-error letter-spacing is now tokenized in bricks
                        letterSpacing: "-0.03em",
                        whiteSpace: "nowrap",
                        as: "h2",
                        mb: "0",
                        textOverflow: "ellipsis",
                        overflow: "hidden"
                    }, subtitleProps), {
                        children: subtitle
                    }))
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                justifySelf: "flex-end",
                flexBasis: hasTitle ? "50%" : "auto",
                justifyContent: "flex-end",
                alignItems: "center",
                flexShrink: 2,
                minWidth: hasTitle ? "auto" : 0,
                children: rightComponent
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/property/media/Modal/index.tsx













var CloseButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button_Button/* default */.ZP, {
    target: "e12f439n0"
})("border:none;box-shadow:none;");
var Modal = function(_param) {
    var analyticsName = _param.analyticsName, _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, height = _param.height, _minHeight = _param.minHeight, minHeight = _minHeight === void 0 ? 200 : _minHeight, _overflow = _param.overflow, overflow = _overflow === void 0 ? "auto" : _overflow, _shouldCloseOnOverlayClick = _param.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick, onRequestClose = _param.onRequestClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "isOpen",
        "height",
        "minHeight",
        "overflow",
        "shouldCloseOnOverlayClick",
        "onRequestClose"
    ]);
    var ref = (0,react.useState)(false), isScrollingBodyPrevented = ref[0], setisScrollingBodyPrevented = ref[1];
    var ref1 = (0,react.useState)(false), showDivider = ref1[0], setShowDivider = ref1[1];
    var handleScroll = (0,react.useCallback)(function(e) {
        return setShowDivider(e.currentTarget.scrollTop > 0);
    }, []);
    var isMobile = (0,useMedia/* useDevice */.F)().isMobile;
    /*
      Scrolling needs to be blocked on elements behind the modal for a better accessable design.
      The useEffect below blocks scrolling when modal is opened.
      https://chakra-ui.com/docs/overlay/modal#keyboard-and-focus-management
  */ (0,react.useEffect)(function() {
        // Need specific styling for iOS body touchscreen
        // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
        if (!isOpen && !isScrollingBodyPrevented) {
            // does not run rest of code in the useEffect since modal has not been opened & is not in the process of being opened
            // this is needed for pages that have multiple modals on the page
            return;
        }
        if (isMobile && isOpen) {
            document.body.style.overflow = "hidden";
            setisScrollingBodyPrevented(true);
        } else if (isMobile && !isOpen) {
            document.body.style.overflow = "visible";
            setisScrollingBodyPrevented(true);
        } else if (isOpen) {
            // non-mobile styling
            document.body.style.overflow = "hidden";
            setisScrollingBodyPrevented(true);
        } else {
            document.body.style.overflow = "visible";
            setisScrollingBodyPrevented(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        isScrollingBodyPrevented
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((lib_default()), {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        closeTimeoutMS: 300,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        style: {
            content: {
                margin: "auto",
                overflow: overflow,
                minHeight: minHeight,
                padding: 0,
                left: "auto",
                right: "auto",
                border: "none",
                display: "flex",
                flexDirection: "column",
                alignSelf: "start",
                position: "fixed",
                maxHeight: "100%",
                maxWidth: "100vw",
                width: "100vw",
                height: "100%"
            },
            overlay: {
                zIndex: 5
            }
        },
        /*
        Accessibility note: Aria-model indicates the presence of a modal element
        https://www.w3.org/TR/wai-aria-1.2/#aria-modal
      */ "aria-modal": isOpen,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODTheme/* Themed */.G, {
            theme: "novo",
            children: [
                "headerProps" in props && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                            flexGrow: 0,
                            zIndex: 2000,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBar, (0,_object_spread/* default */.Z)({
                                rightComponent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButtonStyled, {
                                    id: "modal-close-button",
                                    onClick: onRequestClose,
                                    variant: "icon",
                                    analyticsName: "".concat(analyticsName, "-close"),
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconX/* default */.Z, {
                                        size: 16,
                                        "aria-hidden": "true"
                                    })
                                })
                            }, "headerProps" in props ? props.headerProps : {}))
                        }),
                        showDivider && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                    p: 0,
                    flexGrow: 1,
                    overflowY: "scroll",
                    sx: {
                        "&::-webkit-scrollbar": {
                            display: "none"
                        },
                        msOverflowStyle: "none",
                        scrollbarWidth: "none"
                    },
                    overflow: overflow,
                    onScroll: handleScroll,
                    children: props.children
                })
            ]
        })
    });
};
/* harmony default export */ var media_Modal = (Modal);

;// CONCATENATED MODULE: ./src/components/marketplace/property/media/MobileModalContent.tsx









var MapContent;
(function(MapContent) {
    MapContent["MAP"] = "Map";
    MapContent["STREETVIEW"] = "Street view";
})(MapContent || (MapContent = {}));
var MobileModalContent = /*#__PURE__*/ react.memo(function(param) {
    var address = param.address, closeModal = param.closeModal, contentToShow = param.contentToShow, isModalOpen = param.isModalOpen, latitude = param.latitude, longitude = param.longitude, openLightbox = param.openLightbox, photos = param.photos, price = param.price, openShareModal = param.openShareModal;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(MapContent.MAP), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,useInView/* useInViewAfterLoad */.D)({
        triggerOnce: true,
        initialInView: true,
        ref: ref
    }), inViewMapPage = ref2.inView;
    var mappedPhotos = (0,react.useMemo)(function() {
        return (photos === null || photos === void 0 ? void 0 : photos.map(function(photo) {
            return {
                url: photo + "?service=cosmos&preset=3%3A2-md&presetScale=2%2F3&dpr=1",
                alt: ""
            };
        }, [
            photos
        ])) || [];
    }, [
        photos
    ]);
    var switchToMap = function() {
        return setContent(MapContent.MAP);
    };
    var switchToStreetView = function() {
        return setContent(MapContent.STREETVIEW);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(media_Modal, {
        overflow: contentToShow === ModalContent.MAP ? "hidden" : "auto",
        isOpen: isModalOpen,
        analyticsName: "marketplace-mobile-photo-gallery-modal",
        onRequestClose: closeModal,
        headerProps: {
            rightComponent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ShareButton */.Tz, {
                analyticsName: "marketplace-mobile-photo-gallery-share-button",
                size: "medium",
                onPress: openShareModal
            }),
            title: price ? (0,currencyHelpers/* formatCurrency */.xG)(price) : "Price not available",
            titleProps: {
                fontSize: "16px",
                alignSelf: "center",
                paddingTop: "12px"
            },
            subtitleProps: {
                fontSize: "12px",
                alignSelf: "center",
                color: "warmgrey800"
            },
            subtitle: address || "Address not available",
            leftComponent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ChevronBackButton */.jd, {
                analyticsName: "marketplace-mobile-photo-gallery-back-button",
                size: "medium",
                onPress: closeModal,
                "data-testid": "marketplace-mobile-photo-gallery-back-button"
            })
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            height: "100%",
            "data-testid": "mobile-image-gallery",
            children: [
                contentToShow === ModalContent.PHOTOS && mappedPhotos.map(function(photo, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        mb: "$3x",
                        onPress: function() {
                            return openLightbox(idx);
                        },
                        analyticsName: "marketplace-mobile-photo-gallery-photo-clicked",
                        "aria-label": "image gallery photo ".concat(idx + 1),
                        padding: 0,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                            alt: photo.alt || "property photo",
                            source: {
                                uri: photo.url
                            },
                            width: "100%",
                            height: "auto",
                            aspectRatio: 3 / 2
                        })
                    }, "".concat(idx, "-photo"));
                }),
                contentToShow === ModalContent.MAP && latitude && longitude && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    height: "100%",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            backgroundColor: "$backgroundPrimary",
                            flexDirection: "row",
                            justifyContent: "center",
                            height: 50,
                            alignItems: "center",
                            width: "100%",
                            minHeight: 50,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                    analyticsName: "marketplace-mobile-modal-map-button",
                                    "aria-label": "Map",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    px: 20,
                                    width: "50%",
                                    onPress: switchToMap,
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: content === MapContent.MAP ? "$contentPrimary" : "$contentTertiary",
                                        fontWeight: content === MapContent.MAP ? "$medium" : "$regular",
                                        children: "Map"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                    analyticsName: "marketplace-mobile-modal-street-view-button",
                                    "aria-label": "Street view",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    px: 20,
                                    width: "50%",
                                    onPress: switchToStreetView,
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: content === MapContent.STREETVIEW ? "$contentPrimary" : "$contentTertiary",
                                        fontWeight: content === MapContent.STREETVIEW ? "$medium" : "$regular",
                                        children: "Street view"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            height: "calc(100% - 50px)",
                            children: [
                                content === MapContent.MAP && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Map, {
                                    latitude: latitude,
                                    longitude: longitude
                                }, "property-location"),
                                content === MapContent.STREETVIEW && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicComponentWithCondition, {
                                        dynamicLoaderFunction: function() {
                                            return __webpack_require__.e(/* import() */ 7031).then(__webpack_require__.bind(__webpack_require__, 57031)).then(function(mod) {
                                                return mod.InteractiveGoogleStreetView;
                                            });
                                        },
                                        loadingCondition: inViewMapPage,
                                        latitude: latitude,
                                        longitude: longitude,
                                        addressControl: true,
                                        linksControl: true,
                                        zoomControl: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
MobileModalContent.displayName = "MobileModalContent";

;// CONCATENATED MODULE: ./src/components/marketplace/property/media/PhotoCarousel.tsx






var ModalContent;
(function(ModalContent) {
    ModalContent["PHOTOS"] = "photos";
    ModalContent["MAP"] = "map";
})(ModalContent || (ModalContent = {}));
var MAP_MARKER_ICON = "https://images.opendoor.com/source/s3/imgdrop-production/2024-06-1719508347054-73258.png?preset=square-128";
var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
var PhotoCarousel_PhotoCarousel = function(param) {
    var photos = param.photos, address = param.address, price = param.price, toggleLightbox = param.toggleLightbox, setSelectedPhotoIndex = param.setSelectedPhotoIndex, latitude = param.latitude, longitude = param.longitude, openShareModal = param.openShareModal;
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var ref1 = (0,react.useState)(PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT), aspectRatio = ref1[0], setAspectRatio = ref1[1];
    var ref2 = (0,react.useState)(ModalContent.PHOTOS), modalContent = ref2[0], setModalContent = ref2[1];
    var carouselRef = (0,react.useRef)(null);
    var mappedPhotos = (0,react.useMemo)(function() {
        return (photos === null || photos === void 0 ? void 0 : photos.map(function(photo) {
            return {
                url: photo + "?service=cosmos&preset=3%3A2-md&presetScale=2%2F3&dpr=1",
                alt: ""
            };
        }, [
            photos
        ])) || [];
    }, [
        photos
    ]);
    var togglePhotoModal = function() {
        trackProperty("property-images", "marketplace-pdp-mobile-gallery");
        setIsModalOpen(function(prev) {
            return !prev;
        });
        setModalContent(ModalContent.PHOTOS);
    };
    var toggleMapModal = function() {
        setIsModalOpen(function(prev) {
            return !prev;
        });
        setModalContent(ModalContent.MAP);
    };
    (0,react.useEffect)(function() {
        var carousel = carouselRef.current;
        var startY = 0;
        var startX = 0;
        var handleTouchStart = function(e) {
            startY = e.touches[0].clientY; // Set start Y to the initial touch Y position
            startX = e.touches[0].clientX; // Set start X to the initial touch X position
        };
        var handleTouchMove = function(e) {
            // Calculate the difference between current touch position and start position
            var moveY = e.touches[0].clientY - startY;
            var moveX = e.touches[0].clientX - startX;
            // We're doing this because we want to allow vertical scrolling
            // if the user starts scrolling vertically first
            // But if they start scrolling horizontally first, we want to prevent vertical scrolling
            if (Math.abs(moveX) > Math.abs(moveY)) {
                e.preventDefault(); // Prevent Vertical scrolling
            } else {
                e.stopPropagation(); // Prevent Horizontal scrolling
            }
        };
        if (carousel) {
            carousel.addEventListener("touchstart", handleTouchStart, {
                passive: true
            });
            carousel.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
        }
        return function() {
            if (carousel) {
                // Clean up event listeners
                carousel.removeEventListener("touchstart", handleTouchStart);
                carousel.removeEventListener("touchmove", handleTouchMove);
            }
        };
    }, [
        carouselRef
    ]);
    var closeModal = function() {
        setIsModalOpen(false);
    };
    var CarouselWidths = {
        smallest: 360,
        small: 375,
        smallMedium: 600,
        medium: 768,
        mediumLarge: 992
    };
    var _obj;
    var WIDTH_TO_ASPECT_RATIO = (_obj = {}, (0,_define_property/* default */.Z)(_obj, CarouselWidths.smallest, PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT), (0,_define_property/* default */.Z)(_obj, CarouselWidths.small, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), (0,_define_property/* default */.Z)(_obj, CarouselWidths.smallMedium, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), (0,_define_property/* default */.Z)(_obj, CarouselWidths.medium, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), (0,_define_property/* default */.Z)(_obj, CarouselWidths.mediumLarge, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), _obj);
    useIsomorphicLayoutEffect(function() {
        // Function to calculate and set the aspect ratio
        var updateAspectRatio = function() {
            var containerWidth = window.innerWidth;
            var newAspectRatio = PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT; // Default aspect ratio
            if (containerWidth < CarouselWidths.smallest) {
                newAspectRatio = PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT;
            } else if (containerWidth <= CarouselWidths.small) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.small];
            } else if (containerWidth < CarouselWidths.smallMedium) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.smallMedium];
            } else if (containerWidth <= CarouselWidths.medium) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.medium];
            } else if (containerWidth <= CarouselWidths.mediumLarge) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.mediumLarge];
            }
            setAspectRatio(newAspectRatio);
        };
        // Call updateAspectRatio initially to set the aspect ratio based on the current window size
        updateAspectRatio();
        // Add event listener for window resize
        window.addEventListener("resize", updateAspectRatio);
        // Cleanup function to remove the event listener
        return function() {
            return window.removeEventListener("resize", updateAspectRatio);
        };
    }, []);
    var openLightbox = function(selectedImageIndex) {
        trackProperty("property-images", "marketplace-pdp-lightbox");
        setSelectedPhotoIndex && setSelectedPhotoIndex(selectedImageIndex);
        toggleLightbox && toggleLightbox();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        aspectRatio: aspectRatio,
        width: "100%",
        ref: carouselRef,
        $largerThanSM: {
            display: "none"
        },
        mt: 55,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PhotoCarousel/* PhotoCarousel */.c, {
                photos: mappedPhotos,
                hideNavigation: true,
                aspectRatio: aspectRatio,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ChevronBackButton */.jd, {
                        size: "large",
                        onPress: function() {
                            return history.back();
                        },
                        analyticsName: "marketplace-carousel-back-button",
                        top: "$12x",
                        left: 24,
                        position: "absolute",
                        zIndex: 1
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ShareButton */.Tz, {
                        size: "large",
                        onPress: openShareModal,
                        analyticsName: "marketplace-carousel-share-button",
                        top: "$12x",
                        right: 24,
                        position: "absolute",
                        zIndex: 1
                    }),
                    latitude && longitude && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        "aria-label": "Click to view map",
                        onPress: toggleMapModal,
                        analyticsName: "marketplace-carousel-map-button",
                        bottom: "$10x",
                        right: 24,
                        position: "absolute",
                        zIndex: 1,
                        pressStyle: {
                            scale: 0.95
                        },
                        width: 64,
                        height: 64,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                            alt: "map-button",
                            source: {
                                height: 64,
                                uri: MAP_MARKER_ICON,
                                width: 64
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        // This PressableBox as an absolutely positioned transparent button is required in
                        // order to support the gallery modal. Using a PressableBox wrapper creates a nextjs Hydration
                        // error with the nested buttons so we need to do it this way.
                        "aria-label": "Click to view more photos",
                        onPress: togglePhotoModal,
                        analyticsName: "marketplace-carousel-photo-clicked",
                        padding: 0,
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        backgroundColor: "$transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileModalContent, {
                address: address,
                closeModal: closeModal,
                contentToShow: modalContent,
                isModalOpen: isModalOpen,
                photos: photos,
                price: price,
                latitude: latitude,
                longitude: longitude,
                openLightbox: openLightbox,
                openShareModal: openShareModal
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyCTAs.tsx + 2 modules
var PropertyCTAs = __webpack_require__(28561);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyDetails.tsx + 3 modules
var PropertyDetails = __webpack_require__(20313);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyStatus.tsx
var PropertyStatus = __webpack_require__(46609);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertySummary.tsx
var PropertySummary = __webpack_require__(21572);
;// CONCATENATED MODULE: ./src/components/marketplace/property/PropertySection/index.tsx










var PropertySection = function(param) {
    var property = param.property;
    var ref;
    var ctaRef = (0,react.useRef)(null);
    var inView = (0,useInView/* useInViewAfterLoad */.D)({
        ref: ctaRef,
        threshold: 0,
        initialInView: true
    }).inView;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        $largerThanSM: {
            flexBasis: "50%",
            mt: 55,
            overflowY: "scroll"
        },
        $largerThanLG: {
            maxWidth: "$736x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                $largerThanSM: {
                    px: 48
                },
                $smallerThanMD: {
                    px: 24
                },
                pt: 24,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyStatus/* PropertyStatus */.R, {
                        property: property
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertySummary/* PropertySummary */.b, {
                        property: property
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        ref: ctaRef,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyCTAs/* PropertyCTAs */.y, {
                            property: property
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        mt: 48
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyDetails/* PropertyDetails */.l, {
                        property: property
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: "section",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimilarListings/* SimilarListings */.C, {
                            listings: (property === null || property === void 0 ? void 0 : (ref = property.similarProperties) === null || ref === void 0 ? void 0 : ref.results) || []
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCTA, {
                property: property,
                isVisible: !inView
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(60179);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toast/Toast.js + 3 modules
var Toast = __webpack_require__(64370);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconMessage.mjs
var IconMessage = __webpack_require__(54666);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconMail.mjs
var IconMail = __webpack_require__(79384);
// EXTERNAL MODULE: ./src/components/helpers/links.ts
var links = __webpack_require__(98417);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
;// CONCATENATED MODULE: ./src/components/marketplace/property/ShareModal.tsx








function getShareableContent(slug, addressToken) {
    return "Check out this home for sale on Opendoor!\n\n".concat(getShareableLink(slug, addressToken));
}
function getShareableLink(slug, addressToken) {
    return "www.opendoor.com".concat((0,links/* corePdpLink */.v)(slug, addressToken));
}
function getEmailLink(slug, addressToken) {
    return "mailto:?body=".concat(encodeURIComponent(getShareableContent(slug, addressToken)));
}
function getTextMessageLink(slug, addressToken) {
    return "sms:?&body=".concat(encodeURIComponent(getShareableContent(slug, addressToken)));
}
var PRESS_SCALE = 0.98;
var TOAST_DURATION = 1000; // 1 second
var ShareModal = function(param) {
    var property = param.property, isOpen = param.isOpen, onClose = param.onClose;
    var ref = (0,react.useState)(false), isToastOpen = ref[0], setIsToastOpen = ref[1];
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    var copyToClipboard = function(text) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
        }
    };
    var handleOnShare = (0,react.useCallback)(function() {
        trackProperty("property-share", "marketplace-pdp-copy");
        if (property.addressToken) {
            trackJourneyEvent("marketplaceProperty", "share", {
                addressUuid: property.addressToken,
                source: "copy"
            });
        }
        copyToClipboard(getShareableLink(property.slug, property.addressToken));
        setIsToastOpen(true);
        onClose();
    }, []);
    var handleSms = (0,react.useCallback)(function() {
        trackProperty("property-share", "marketplace-pdp-sms");
        window.open(getTextMessageLink(property.slug, property.addressToken), "_self");
        trackJourneyEvent("marketplaceProperty", "share", {
            addressUuid: property.addressToken,
            source: "sms"
        });
    }, []);
    var handleEmail = (0,react.useCallback)(function() {
        trackProperty("property-share", "marketplace-pdp-email");
        trackJourneyEvent("marketplaceProperty", "share", {
            addressUuid: property.addressToken,
            source: "email"
        });
        window.open(getEmailLink(property.slug, property.addressToken), "_self");
    }, []);
    var closeToast = (0,react.useCallback)(function() {
        setIsToastOpen(false);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
                isOpen: isOpen,
                dismissable: true,
                analyticsName: "marketplace-share-modal",
                trackImpression: true,
                setIsOpen: onClose,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    $smallerThanMD: {
                        width: "100%"
                    },
                    $largerThanSM: {
                        width: 300
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            flexDirection: "column",
                            px: 30,
                            py: 24,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$subheaderSmall",
                                            children: "Share"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                                            analyticsName: "close-share-modal",
                                            onPress: onClose,
                                            size: "large",
                                            variant: "default"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodySmall",
                                    color: "$contentSecondary",
                                    mt: 4,
                                    children: formattedStreet
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            onPress: handleOnShare,
                            analyticsName: "property-share-copy",
                            "aria-label": "Copy to clipboard",
                            alignItems: "center",
                            borderColor: "$borderSecondary",
                            borderBottomWidth: 1,
                            py: 24,
                            mx: 32,
                            pressStyle: {
                                scale: PRESS_SCALE
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodySmall",
                                    children: "Copy"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentCopyIcon, {
                                    size: 16
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            onPress: handleSms,
                            analyticsName: "property-share-email",
                            "aria-label": "Share by SMS",
                            alignItems: "center",
                            borderColor: "$borderSecondary",
                            borderBottomWidth: 1,
                            py: 24,
                            mx: 32,
                            pressStyle: {
                                scale: PRESS_SCALE
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodySmall",
                                    children: "SMS"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconMessage/* default */.Z, {
                                    size: 16
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            onPress: handleEmail,
                            analyticsName: "property-share-email",
                            "aria-label": "Share in Email",
                            alignItems: "center",
                            py: 24,
                            mx: 32,
                            pressStyle: {
                                scale: PRESS_SCALE
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodySmall",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconMail/* default */.Z, {
                                    size: 16
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* Toast */.F, {
                analyticsName: "copy-link-toast-success",
                duration: TOAST_DURATION,
                isOpen: isToastOpen,
                message: "Link copied to clipboard",
                onClose: closeToast,
                isSuccess: true
            })
        ]
    });
};
function ContentCopyIcon(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                id: "path-1-inside-1_3070_193338",
                fill: "white",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: "0.5",
                    y: "3.5",
                    width: "12.5",
                    height: "16.25",
                    rx: "1.25"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                x: "0.5",
                y: "3.5",
                width: "12.5",
                height: "16.25",
                rx: "1.25",
                stroke: "black",
                strokeWidth: "3.75",
                mask: "url(#path-1-inside-1_3070_193338)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4.25 1H14.25C14.9404 1 15.5 1.55964 15.5 2.25V16",
                stroke: "black",
                strokeWidth: "1.875"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/marketplace/property/index.ts











/***/ }),

/***/ 95923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useTouring; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35480);
/* harmony import */ var components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95707);
/* harmony import */ var components_marketplace_helpers_propertyActionability__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82799);
/* harmony import */ var helpers_observability__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77997);





var useTouring = function(property, options) {
    var placement = options.placement;
    var trackProperty = (0,components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_2__/* .useTrackProperty */ .ad)().trackProperty;
    var trackJourneyEvent = (0,helpers_observability__WEBPACK_IMPORTED_MODULE_4__/* .useObservability */ .C3)().trackJourneyEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isDialogOpen = ref[0], setIsDialogOpen = ref[1];
    var ref1 = (0,components_marketplace_helpers_propertyActionability__WEBPACK_IMPORTED_MODULE_3__/* .determinePropertyActionability */ .zf)(property), isActionable = ref1.isActionable, tourKind = ref1.tourKind, showBuyDirect = ref1.showBuyDirect, disableBuyDirect = ref1.disableBuyDirect;
    if (!isActionable || !tourKind) {
        return null;
    }
    var tourUrl = "".concat(components_globals__WEBPACK_IMPORTED_MODULE_1__/* .CONSUMER_URL */ .Kz, "/dashboard/buy/tour?id=").concat(property.addressToken);
    var buyDirectUrl = "".concat(components_globals__WEBPACK_IMPORTED_MODULE_1__/* .CONSUMER_URL */ .Kz, "/dashboard/buy/checkout?id=").concat(property.addressToken);
    // Analytics naming differs by placement:
    // | Placement      | Analytics Name Pattern                              |
    // |----------------|-----------------------------------------------------|
    // | main           | cosmos-marketplace-{action}-cta                     |
    // | footer/lightbox| cosmos-marketplace-pdp-{placement}-{action}-button  |
    var isMainPlacement = placement === "main";
    var trackPropertySource = isMainPlacement ? "marketplace-pdp" : "marketplace-pdp-".concat(placement, "-cta");
    var journeyEventPlacement = isMainPlacement ? "above-the-fold" : placement;
    var analyticsNamePrefix = isMainPlacement ? "cosmos-marketplace" : "cosmos-marketplace-pdp-".concat(placement);
    var analyticsNameSuffix = isMainPlacement ? "cta" : "button";
    var handleSelfTour = function() {
        trackProperty("property-self-tour", trackPropertySource);
        trackJourneyEvent("marketplaceProperty", "tourBookingStart", {
            addressUuid: property.addressToken,
            placement: journeyEventPlacement
        });
    };
    var handleBuyDirect = function() {
        trackProperty("property-buy-direct", trackPropertySource);
        trackJourneyEvent("marketplaceProperty", "offerStart", {
            addressUuid: property.addressToken,
            source: journeyEventPlacement
        });
    };
    var handleTourWithAgent = function() {
        setIsDialogOpen(true);
    };
    var closeDialog = function() {
        return setIsDialogOpen(false);
    };
    // Determine primary and secondary actions based on property state
    var primaryAction;
    var secondaryAction = null;
    if (showBuyDirect) {
        // BuyDirect eligible properties show Buy button as primary
        primaryAction = {
            text: disableBuyDirect ? "Offer pending" : "Buy this home",
            onClick: handleBuyDirect,
            href: buyDirectUrl,
            target: "_blank",
            variant: "primary",
            disabled: disableBuyDirect,
            analyticsName: "".concat(analyticsNamePrefix, "-buy-direct-").concat(analyticsNameSuffix)
        };
        // Show tour as secondary action based on tour kind
        if (tourKind === "selfTour") {
            secondaryAction = {
                text: components_marketplace_helpers_propertyActionability__WEBPACK_IMPORTED_MODULE_3__/* .TOUR_ACTION_TEXT_BUY_DIRECT.selfTour */ .fM.selfTour,
                onClick: handleSelfTour,
                href: tourUrl,
                target: "_blank",
                variant: placement === "lightbox" ? "secondaryInverse" : "secondary",
                analyticsName: "".concat(analyticsNamePrefix, "-self-tour-").concat(analyticsNameSuffix)
            };
        } else if (tourKind === "tourWithAgent") {
            secondaryAction = {
                text: components_marketplace_helpers_propertyActionability__WEBPACK_IMPORTED_MODULE_3__/* .TOUR_ACTION_TEXT_BUY_DIRECT.tourWithAgent */ .fM.tourWithAgent,
                onClick: handleTourWithAgent,
                variant: placement === "lightbox" ? "secondaryInverse" : "secondary",
                analyticsName: "".concat(analyticsNamePrefix, "-tour-with-agent-").concat(analyticsNameSuffix)
            };
        }
    } else if (tourKind === "selfTour") {
        primaryAction = {
            text: components_marketplace_helpers_propertyActionability__WEBPACK_IMPORTED_MODULE_3__/* .TOUR_ACTION_TEXT_NON_BUY_DIRECT.selfTour */ .ms.selfTour,
            onClick: handleSelfTour,
            href: tourUrl,
            target: "_blank",
            variant: placement === "lightbox" ? "secondaryInverse" : "primary",
            analyticsName: "".concat(analyticsNamePrefix, "-self-tour-").concat(analyticsNameSuffix)
        };
    } else {
        primaryAction = {
            text: components_marketplace_helpers_propertyActionability__WEBPACK_IMPORTED_MODULE_3__/* .TOUR_ACTION_TEXT_NON_BUY_DIRECT.tourWithAgent */ .ms.tourWithAgent,
            onClick: handleTourWithAgent,
            variant: placement === "lightbox" ? "secondaryInverse" : "primary",
            analyticsName: "".concat(analyticsNamePrefix, "-tour-with-agent-").concat(analyticsNameSuffix)
        };
    }
    return {
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        tourKind: tourKind,
        showBuyDirect: showBuyDirect,
        isDialogOpen: isDialogOpen,
        closeDialog: closeDialog
    };
};


/***/ }),

/***/ 53456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useInViewAfterLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70131);
/* harmony import */ var _useOnLoad__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17919);



/**
 * In most cases, the "useInView" helper doesn't need to attach and start
 * tracking until after the page load has already happened.
 */ var useInViewAfterLoad = function(opts) {
    var afterLoad = (0,_useOnLoad__WEBPACK_IMPORTED_MODULE_1__/* .useOnLoad */ .g)();
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        inView: (ref = opts === null || opts === void 0 ? void 0 : opts.initialInView) !== null && ref !== void 0 ? ref : false,
        entry: undefined
    }), ref2 = ref1[0], inView = ref2.inView, entry = ref2.entry, setState = ref1[1];
    // Use an existing ref (passed in) instead of creating it internally
    // which avoids the bad behavior of the "useInView" hook from the
    // react-intersection-observer which re-renders multiple times
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!afterLoad || !opts.ref.current || opts.skip) {
            return;
        }
        var unobserve = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_2__/* .observe */ .N7)(opts.ref.current, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && opts.triggerOnce && unobserve) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve();
                unobserve = undefined;
            }
        }, {
            root: opts.root,
            rootMargin: opts.rootMargin,
            threshold: opts.threshold
        }, opts.fallbackInView);
        return function() {
            if (unobserve) {
                unobserve();
            }
        };
    }, [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(opts.threshold) ? opts.threshold.toString() : opts.threshold,
        opts.ref,
        opts.root,
        opts.rootMargin,
        opts.triggerOnce,
        opts.skip,
        opts.fallbackInView,
        afterLoad, 
    ]);
    return {
        inView: inView,
        entry: entry
    };
};


/***/ }),

/***/ 17919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useOnLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// Periodically we want to load something after the window has loaded. This will
// do that, it also adds a buffer so it's definitely "afterLoad", these are for
// low-priority things.
var useOnLoad = function() {
    var onLoadStateChange = function onLoadStateChange() {
        setTimeout(function() {
            return setIsAfterLoad(true);
        }, 1000);
    };
    var handleLoadStateCleanup = function handleLoadStateCleanup() {
        window.removeEventListener("load", onLoadStateChange);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(// handle ssr
    typeof document === "undefined" ? false : document.readyState === "complete"), isAfterLoad = ref[0], setIsAfterLoad = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAfterLoad) {
            handleLoadStateCleanup();
            return;
        }
        window.addEventListener("load", onLoadStateChange);
        return handleLoadStateCleanup;
    }, [
        isAfterLoad
    ]);
    return isAfterLoad;
};


/***/ })

}]);